import "./sdk.gen-DVdZJ1Om.js";
//#region src/generated/schemas.gen.ts
var e = {
	type: "string",
	minLength: 2,
	maxLength: 2,
	pattern: "[A-Z]{2}",
	description: "ISO 3166-1 alpha-2 country code."
}, t = {
	type: "object",
	properties: {
		city: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The city of the address."
		},
		countryCode: { $ref: "#/components/schemas/CountryCode" },
		street: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The street of the address."
		},
		additionalInformation: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "Additional information about the address."
		},
		boxNumber: {
			type: "string",
			minLength: 1,
			maxLength: 20,
			description: "The box number of the address, only applicable for specific country codes."
		},
		houseNumber: {
			type: "string",
			minLength: 1,
			maxLength: 25,
			description: "The house number of the address."
		},
		houseNumberSuffix: {
			type: "string",
			minLength: 1,
			maxLength: 25,
			description: "The house number suffix of the address."
		},
		postalCode: {
			type: "string",
			minLength: 1,
			maxLength: 15,
			description: "The postal code of the address."
		},
		region: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The region of the address."
		},
		state: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The state of the address."
		}
	},
	required: [
		"city",
		"countryCode",
		"street"
	],
	description: "A physical address."
}, n = {
	type: "string",
	enum: [
		"BPOST",
		"BRT",
		"CHEAP_CARGO",
		"DHL_EUROPLUS",
		"DHL_FOR_YOU",
		"DHL_PARCEL_CONNECT",
		"DPD",
		"GLS",
		"INPOST",
		"POSTNL",
		"POSTE_ITALIANE",
		"TRUNKRS",
		"UPS_EXPRESS_SAVER",
		"UPS_STANDARD",
		"VIA_TIM",
		"BOL"
	],
	description: "The carrier of the package."
}, r = {
	type: "string",
	enum: [
		"BPOST",
		"BRT",
		"CHEAP_CARGO",
		"DHL_EUROPLUS",
		"DHL_FOR_YOU",
		"DHL_PARCEL_CONNECT",
		"DPD",
		"GLS",
		"INPOST",
		"POSTNL",
		"POSTE_ITALIANE",
		"TRUNKRS",
		"UPS_EXPRESS_SAVER",
		"UPS_STANDARD",
		"VIA_TIM"
	],
	description: "The carrier to select to ship a package with."
}, i = {
	type: "object",
	properties: {
		groups: {
			type: "array",
			items: {
				type: "object",
				properties: {
					description: {
						type: "string",
						minLength: 1,
						maxLength: 50,
						description: "A clear and detailed description of the goods within this group."
					},
					hsCode: {
						type: "string",
						minLength: 6,
						maxLength: 12,
						description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products."
					},
					numberOfItems: {
						type: "integer",
						minimum: 1,
						maximum: 99999,
						description: "The total quantity of individual items within this specific group."
					},
					totalValue: {
						type: "object",
						properties: {
							currency: {
								type: "string",
								minLength: 3,
								maxLength: 3,
								description: "ISO 4217 three-letter currency code."
							},
							micros: {
								type: "integer",
								minimum: 0,
								maximum: 9007199254740991,
								description: "The amount of money in integer micros."
							}
						},
						required: ["currency", "micros"],
						description: "The total declared value of all items within this group."
					},
					totalWeight: {
						type: "object",
						properties: {
							unit: {
								type: "string",
								enum: ["g", "kg"],
								description: "The unit of weight."
							},
							value: {
								type: "integer",
								minimum: 1,
								maximum: 999999999
							}
						},
						required: ["unit", "value"],
						description: "The total weight of all items within this specific group."
					},
					countryCodeOfOrigin: { allOf: [{ $ref: "#/components/schemas/CountryCode" }, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." }] }
				},
				required: [
					"description",
					"hsCode",
					"numberOfItems",
					"totalValue",
					"totalWeight"
				],
				description: "A consolidated group of items within a customs declaration that share common customs attributes."
			},
			minItems: 1,
			maxItems: 100,
			description: "The list of item groups."
		},
		purpose: {
			type: "string",
			enum: [
				"COMMERCIAL_GOODS",
				"COMMERCIAL_SAMPLE",
				"DOCUMENTS",
				"GIFT",
				"RETURNED_GOODS"
			],
			description: "The primary reason or purpose for the international shipment."
		},
		totalWeight: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: ["g", "kg"],
					description: "The unit of weight."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 999999999
				}
			},
			required: ["unit", "value"],
			description: "The total weight of all items declared within this customs declaration."
		},
		invoiceNumber: {
			type: "string",
			minLength: 1,
			maxLength: 150,
			description: "The identifying number of the commercial invoice associated with this shipment."
		}
	},
	required: [
		"groups",
		"purpose",
		"totalWeight"
	],
	description: "The official declaration of goods for customs clearance purposes during international shipment."
}, a = {
	type: "object",
	properties: {
		groups: {
			type: "array",
			items: {
				type: "object",
				properties: {
					description: {
						type: "string",
						minLength: 1,
						maxLength: 100,
						description: "A clear and detailed description of the goods within this group."
					},
					hsCode: {
						type: "string",
						minLength: 6,
						maxLength: 12,
						description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products."
					},
					numberOfItems: {
						type: "integer",
						minimum: 1,
						maximum: 99999,
						description: "The total quantity of individual items within this specific group."
					},
					totalValue: {
						type: "object",
						properties: {
							currency: {
								type: "string",
								minLength: 3,
								maxLength: 3,
								description: "ISO 4217 three-letter currency code."
							},
							micros: {
								type: "integer",
								minimum: 0,
								maximum: 9007199254740991,
								description: "The amount of money in integer micros."
							}
						},
						required: ["currency", "micros"],
						description: "The total declared value of all items within this group."
					},
					totalWeight: {
						type: "object",
						properties: {
							unit: {
								type: "string",
								enum: ["g", "kg"],
								description: "The total weight of all items within this specific group."
							},
							value: {
								type: "integer",
								minimum: 1,
								maximum: 999999999
							}
						},
						required: ["unit", "value"],
						description: "The total weight of all items within this specific group."
					},
					countryCodeOfOrigin: { allOf: [{ $ref: "#/components/schemas/CountryCode" }, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." }] }
				},
				required: [
					"description",
					"hsCode",
					"numberOfItems",
					"totalValue",
					"totalWeight"
				],
				description: "A consolidated group of items within a customs declaration that share common customs attributes."
			},
			minItems: 1,
			maxItems: 100,
			description: "The list of item groups."
		},
		purpose: {
			type: "string",
			enum: [
				"COMMERCIAL_GOODS",
				"COMMERCIAL_SAMPLE",
				"DOCUMENTS",
				"GIFT",
				"RETURNED_GOODS"
			],
			description: "The primary reason or purpose for the international shipment."
		},
		totalWeight: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: ["g", "kg"],
					description: "The total weight of all items declared within this customs declaration."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 999999999
				}
			},
			required: ["unit", "value"],
			description: "The total weight of all items declared within this customs declaration."
		},
		invoiceNumber: {
			type: "string",
			minLength: 1,
			maxLength: 150,
			description: "The identifying number of the commercial invoice associated with this shipment."
		}
	},
	required: [
		"groups",
		"purpose",
		"totalWeight"
	],
	description: "The official declaration of goods for customs clearance purposes during international shipment."
}, o = {
	type: "string",
	minLength: 1,
	maxLength: 100,
	description: "The customer reference of the order."
}, s = {
	type: "string",
	enum: [
		"EARLY_MORNING_DELIVERY",
		"EVENING_DELIVERY",
		"EXPRESS_DELIVERY",
		"MORNING_DELIVERY",
		"PICKUP_EXPRESS_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"STANDARD_DELIVERY"
	],
	description: "The delivery type of the shipment."
}, c = {
	type: "object",
	properties: {
		notifyOnDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Notify sender upon package delivery."
		},
		preferredDate: {
			type: "object",
			properties: { date: {
				type: "string",
				format: "date",
				description: "Recipient specified preferred delivery date."
			} },
			required: ["date"],
			description: "This option allows you to set a preferred date for delivery, so a drop off date can be calculated."
		}
	},
	description: "Options regarding delivery timing and notifications."
}, l = {
	type: "object",
	properties: {
		options: { $ref: "#/components/schemas/DeliveryOptions" },
		type: { $ref: "#/components/schemas/DeliveryType" }
	},
	description: "The delivery details of the shipment."
}, u = {
	type: "object",
	properties: { date: {
		type: "string",
		format: "date",
		description: "The date at which to drop off the package."
	} },
	description: "The drop-off details."
}, d = {
	type: "object",
	properties: {
		currency: {
			type: "string",
			minLength: 3,
			maxLength: 3,
			description: "ISO 4217 three-letter currency code."
		},
		micros: {
			type: "integer",
			minimum: 0,
			maximum: 9007199254740991,
			description: "The amount of money in integer micros."
		}
	},
	required: ["currency", "micros"],
	description: "A monetary value represented by split integral and fractional parts to avoid floating point errors."
}, f = {
	type: "string",
	enum: ["EU", "NON_EU"],
	description: "A geographic area code that represents a specific list of countries."
}, p = {
	type: "string",
	enum: [
		"CANCELED",
		"COMPLETED",
		"DISCOVERED",
		"IMPORT_REQUESTED",
		"OPEN",
		"PROCESSING",
		"RETURNING"
	],
	description: "The status of the order."
}, ee = {
	type: "string",
	enum: [
		"DIGITAL_STAMP",
		"ENVELOPE",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE",
		"UNFRANKED"
	],
	description: "The type of the package."
}, te = { anyOf: [
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["PICKING_AND_PACKING"]
			},
			name: {
				type: "string",
				enum: ["PACKED"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DISPATCHING"]
			},
			name: {
				type: "string",
				enum: ["READY_TO_SHIP"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DISPATCHING"]
			},
			name: {
				type: "string",
				enum: ["LABELED"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DISPATCHING"]
			},
			name: {
				type: "string",
				enum: ["HANDED_OVER"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["UNTRACEABLE"]
			},
			name: {
				type: "string",
				enum: ["LABELED"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["SORTING"]
			},
			name: {
				type: "string",
				enum: ["IN_SORTING_PROCESS"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DISTRIBUTING"]
			},
			name: {
				type: "string",
				enum: ["OUT_FOR_DELIVERY"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DISTRIBUTING"]
			},
			name: {
				type: "string",
				enum: ["AT_CUSTOMS"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DISTRIBUTING"]
			},
			name: {
				type: "string",
				enum: ["AT_PICKUP_POINT"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DELIVERED"]
			},
			name: {
				type: "string",
				enum: ["AT_AGREED_LOCATION"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DELIVERED"]
			},
			name: {
				type: "string",
				enum: ["AT_RECIPIENT"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DELIVERED"]
			},
			name: {
				type: "string",
				enum: ["AT_SENDER"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DELIVERED"]
			},
			name: {
				type: "string",
				enum: ["MARKED_AS"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DELIVERED"]
			},
			name: {
				type: "string",
				enum: ["PICKED_UP"]
			}
		},
		required: ["group", "name"]
	}
] }, ne = {
	type: "string",
	enum: [
		"PAID",
		"PENDING",
		"UNPAID"
	],
	description: "The current payment status."
}, re = {
	type: "object",
	properties: {
		height: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: [
						"mm",
						"cm",
						"m"
					],
					description: "The unit of measurement for length, width, or height."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 1e6,
					description: "The dimension value."
				}
			},
			required: ["unit", "value"],
			description: "The height."
		},
		length: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: [
						"mm",
						"cm",
						"m"
					],
					description: "The unit of measurement for length, width, or height."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 1e6,
					description: "The dimension value."
				}
			},
			required: ["unit", "value"],
			description: "The length."
		},
		weight: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: ["g", "kg"],
					description: "The unit of weight."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 999999999
				}
			},
			required: ["unit", "value"],
			description: "The weight."
		},
		width: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: [
						"mm",
						"cm",
						"m"
					],
					description: "The unit of measurement for length, width, or height."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 1e6,
					description: "The dimension value."
				}
			},
			required: ["unit", "value"],
			description: "The width."
		}
	}
}, m = {
	type: "object",
	properties: {
		height: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: [
						"mm",
						"cm",
						"m"
					],
					description: "The unit of measurement for length, width, or height."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 1e6,
					description: "The dimension value."
				}
			},
			required: ["unit", "value"],
			description: "The height."
		},
		length: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: [
						"mm",
						"cm",
						"m"
					],
					description: "The unit of measurement for length, width, or height."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 1e6,
					description: "The dimension value."
				}
			},
			required: ["unit", "value"],
			description: "The length."
		},
		weight: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: ["g", "kg"],
					description: "The unit of weight."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 999999999
				}
			},
			required: ["unit", "value"],
			description: "The physical weight."
		},
		width: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: [
						"mm",
						"cm",
						"m"
					],
					description: "The unit of measurement for length, width, or height."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 1e6,
					description: "The dimension value."
				}
			},
			required: ["unit", "value"],
			description: "The width."
		}
	},
	required: ["weight"],
	description: "The physical dimensions."
}, h = {
	anyOf: [{ $ref: "#/components/schemas/CountryCode" }, { $ref: "#/components/schemas/GeoAreaCode" }],
	description: "A region identifier: either an ISO country code or a defined geographic area."
}, g = {
	type: "string",
	enum: ["OUTBOUND", "INBOUND"],
	description: "The direction of the shipment. OUTBOUND is from sender to recipient, INBOUND is from recipient to sender."
}, ie = {
	type: "object",
	properties: {
		additionalInsurance: {
			type: "object",
			additionalProperties: !1,
			description: "Provides enhanced insurance coverage beyond the standard amount."
		},
		deliverAtPostalPoint: {
			type: "object",
			additionalProperties: !1,
			description: "Indicates that the parcel will be delivered to a designated postal service point rather than the recipient's address, requiring the recipient to collect it from that location."
		},
		freshFood: {
			type: "object",
			additionalProperties: !1,
			description: "Designates the shipment as containing perishable, non-frozen food items, ensuring appropriate handling procedures are applied to maintain freshness and prevent spoilage during transit."
		},
		frozen: {
			type: "object",
			additionalProperties: !1,
			description: "Specifies that the shipment contains items that must remain frozen, necessitating strict, continuous temperature-controlled environments throughout the transit process to prevent thawing."
		},
		hideSender: {
			type: "object",
			additionalProperties: !1,
			description: "Omits the sender's information from the shipping label, maintaining sender anonymity in the delivery process."
		},
		insurance: {
			type: "object",
			properties: { amount: {
				type: "object",
				properties: {
					currency: {
						type: "string",
						minLength: 3,
						maxLength: 3,
						description: "ISO 4217 three-letter currency code."
					},
					micros: {
						type: "integer",
						minimum: 0,
						maximum: 9007199254740991,
						description: "The amount of money in integer micros."
					}
				},
				required: ["currency", "micros"],
				description: "The amount to insure."
			} },
			required: ["amount"],
			description: "Provides standard insurance coverage up to the specified monetary amount."
		},
		noTracking: {
			type: "object",
			additionalProperties: !1,
			description: "Disables all tracking and tracing capabilities for the shipment."
		},
		oversizedPackage: {
			type: "object",
			additionalProperties: !1,
			description: "Designates the shipment as exceeding standard size limitations, requiring special handling procedures and potentially incurring additional fees."
		},
		printReturnLabelAtDropOff: {
			type: "object",
			additionalProperties: !1,
			description: "Provides the recipient with a digital identifier that can be presented at a drop-off location to print the return label on-site. This option is only applicable for inbound shipments."
		},
		priorityDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Designates the shipment for expedited processing and transport through the delivery network, often resulting in a faster transit time compared to standard services."
		},
		recipientOnlyDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Restricts delivery exclusively to the named recipient, requiring verification of recipient identity and prohibiting delivery to anyone else at the same address."
		},
		requiresAgeVerification: {
			type: "object",
			additionalProperties: !1,
			description: "Requires the recipient to provide valid identification to verify they meet the minimum age requirement before the package can be released, typically used for age-restricted items."
		},
		requiresCashOnDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Mandates that the carrier collect the full order amount in cash from the recipient upon delivery, ensuring payment is secured before the goods are handed over."
		},
		requiresReceiptCode: {
			type: "object",
			additionalProperties: !1,
			description: "Requires the recipient to provide a specific verification code at the time of delivery, adding an extra layer of security and confirmation for sensitive shipments."
		},
		requiresSignature: {
			type: "object",
			additionalProperties: !1,
			description: "Mandates that the recipient or authorized representative must provide a signature upon delivery, creating proof of receipt and transfer of responsibility."
		},
		returnContributionFee: {
			type: "object",
			properties: { amount: {
				type: "object",
				properties: {
					currency: {
						type: "string",
						minLength: 3,
						maxLength: 3,
						description: "ISO 4217 three-letter currency code."
					},
					micros: {
						type: "integer",
						minimum: 0,
						maximum: 9007199254740991,
						description: "The amount of money in integer micros."
					}
				},
				required: ["currency", "micros"],
				description: "The amount of the contribution."
			} },
			required: ["amount"],
			description: "Specifies that the recipient must pay the designated contribution amount toward the cost of returning the item. This option is only applicable for inbound shipments."
		},
		returnOnFirstFailedDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Instructs the carrier to return the package to the sender immediately after the first unsuccessful delivery attempt, bypassing the standard redelivery procedures or holding period."
		},
		sameDayDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Expedited delivery within the same calendar day that the shipping label is created."
		},
		saturdayDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Enables delivery on Saturday, which is typically outside standard delivery days, ensuring the package arrives before the start of the following work week."
		},
		scheduledCollection: {
			type: "object",
			additionalProperties: !1,
			description: "Arranges for the carrier to pick up the package from the sender's location, eliminating the need for the sender to drop off the package."
		}
	},
	description: "Options applicable to shipments."
}, ae = {
	type: "object",
	properties: { customLabelText: {
		type: "object",
		properties: { text: {
			type: "string",
			minLength: 1,
			maxLength: 45,
			description: "Allows adding personalized text to be printed on the shipping label, which can include special handling instructions or reference information."
		} },
		required: ["text"],
		description: "Defines a custom text to be printed on the shipping label."
	} },
	description: "Options applicable to individual packages of a shipment."
}, oe = {
	allOf: [{ $ref: "#/components/schemas/ShipmentOptionsCommon" }, { $ref: "#/components/schemas/ShipmentOptionsPackage" }],
	description: "Options applicable to shipments."
}, se = {
	type: "string",
	enum: ["ASC", "DESC"],
	description: "Specifies the ordering of results: ascending (ASC) or descending (DESC)."
}, ce = {
	type: "object",
	properties: {
		emailAddress: {
			type: "string",
			minLength: 1,
			maxLength: 320,
			description: "An email address."
		},
		locale: {
			anyOf: [{
				type: "string",
				minLength: 5,
				maxLength: 5,
				description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen."
			}, {
				type: "string",
				minLength: 2,
				maxLength: 2,
				description: "ISO 639-1 language code."
			}],
			description: "A value that is either a full locale or just a language code."
		},
		phoneNumber: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The phone number of the contact."
		},
		type: {
			type: "string",
			enum: ["BUSINESS"],
			description: "Discriminator for business contacts."
		},
		company: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The name of the company."
		},
		attention: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The name of the contact person."
		},
		vatNumbersByCountry: {
			type: "object",
			additionalProperties: {
				type: "string",
				minLength: 1,
				maxLength: 20,
				description: "The VAT registration number for the given country."
			},
			description: "A collection of VAT registration numbers of the company, indexed by ISO country code.",
			propertyNames: { $ref: "#/components/schemas/CountryCode" }
		},
		voecNumber: {
			type: "string",
			minLength: 1,
			maxLength: 20,
			description: "The VOEC number of the company."
		},
		eoriNumber: {
			type: "string",
			minLength: 1,
			maxLength: 20,
			description: "The EORI number of the company."
		}
	},
	required: ["type", "company"]
}, le = {
	type: "object",
	properties: {
		emailAddress: {
			type: "string",
			minLength: 1,
			maxLength: 320,
			description: "An email address."
		},
		locale: {
			anyOf: [{
				type: "string",
				minLength: 5,
				maxLength: 5,
				description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen."
			}, {
				type: "string",
				minLength: 2,
				maxLength: 2,
				description: "ISO 639-1 language code."
			}],
			description: "A value that is either a full locale or just a language code."
		},
		phoneNumber: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The phone number of the contact."
		},
		type: {
			type: "string",
			enum: ["PRIVATE"],
			description: "Discriminator for private contacts."
		},
		name: {
			type: "string",
			minLength: 1,
			maxLength: 200,
			description: "The name of the contact person."
		}
	},
	required: ["type", "name"]
}, ue = {
	oneOf: [{ $ref: "#/components/schemas/ContactBusiness" }, { $ref: "#/components/schemas/ContactPrivate" }],
	discriminator: {
		propertyName: "type",
		mapping: {
			BUSINESS: "#/components/schemas/ContactBusiness",
			PRIVATE: "#/components/schemas/ContactPrivate"
		}
	}
}, de = {
	type: "object",
	properties: {
		locale: {
			anyOf: [{
				type: "string",
				minLength: 5,
				maxLength: 5,
				description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen."
			}, {
				type: "string",
				minLength: 2,
				maxLength: 2,
				description: "ISO 639-1 language code."
			}],
			description: "A value that is either a full locale or just a language code."
		},
		phoneNumber: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The phone number of the contact."
		},
		type: {
			type: "string",
			enum: ["BUSINESS"],
			description: "Discriminator for business contacts."
		},
		company: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The name of the company."
		},
		attention: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The name of the contact person."
		},
		vatNumbersByCountry: {
			type: "object",
			additionalProperties: {
				type: "string",
				minLength: 1,
				maxLength: 20,
				description: "The VAT registration number for the given country."
			},
			description: "A collection of VAT registration numbers of the company, indexed by ISO country code.",
			propertyNames: { $ref: "#/components/schemas/CountryCode" }
		},
		voecNumber: {
			type: "string",
			minLength: 1,
			maxLength: 20,
			description: "The VOEC number of the company."
		},
		eoriNumber: {
			type: "string",
			minLength: 1,
			maxLength: 20,
			description: "The EORI number of the company."
		},
		emailAddresses: {
			type: "array",
			items: {
				type: "string",
				minLength: 1,
				maxLength: 320,
				description: "An email address."
			},
			minItems: 1,
			maxItems: 5,
			description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present."
		}
	},
	required: ["type", "company"],
	description: "A business contact that supports multiple email addresses."
}, fe = {
	type: "object",
	properties: {
		locale: {
			anyOf: [{
				type: "string",
				minLength: 5,
				maxLength: 5,
				description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen."
			}, {
				type: "string",
				minLength: 2,
				maxLength: 2,
				description: "ISO 639-1 language code."
			}],
			description: "A value that is either a full locale or just a language code."
		},
		phoneNumber: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The phone number of the contact."
		},
		type: {
			type: "string",
			enum: ["PRIVATE"],
			description: "Discriminator for private contacts."
		},
		name: {
			type: "string",
			minLength: 1,
			maxLength: 200,
			description: "The name of the contact person."
		},
		emailAddresses: {
			type: "array",
			items: {
				type: "string",
				minLength: 1,
				maxLength: 320,
				description: "An email address."
			},
			minItems: 1,
			maxItems: 5,
			description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present."
		}
	},
	required: ["type", "name"],
	description: "A private contact that supports multiple email addresses."
}, pe = {
	oneOf: [{ $ref: "#/components/schemas/ContactMultiEmailBusiness" }, { $ref: "#/components/schemas/ContactMultiEmailPrivate" }],
	discriminator: {
		propertyName: "type",
		mapping: {
			BUSINESS: "#/components/schemas/ContactMultiEmailBusiness",
			PRIVATE: "#/components/schemas/ContactMultiEmailPrivate"
		}
	}
}, me = {
	type: "object",
	properties: {
		address: { $ref: "#/components/schemas/Address" },
		contact: { $ref: "#/components/schemas/Contact" }
	},
	description: "The billing details of an order."
}, he = {
	type: "object",
	properties: {
		name: {
			type: "string",
			enum: [
				"BOL",
				"CSCART",
				"LIGHTSPEED",
				"MAGENTO",
				"PRESTA",
				"SHOPIFY",
				"WOOCOMMERCE"
			],
			description: "The identifier of the external e-commerce platform."
		},
		sourceId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The order ID as defined in the source system."
		}
	},
	required: ["name", "sourceId"],
	description: "The external reference of the ecommerce platform."
}, ge = {
	type: "object",
	properties: {
		id: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the sales channel."
		},
		name: {
			type: "string",
			minLength: 3,
			maxLength: 50,
			description: "The name of the sales channel at the time of import."
		}
	},
	required: ["id", "name"],
	description: "The external reference of the sales channel."
}, _e = {
	type: "object",
	properties: {
		source: {
			type: "string",
			enum: ["SALES_CHANNEL"]
		},
		salesChannel: { $ref: "#/components/schemas/ExternalReferenceSalesChannel" },
		ecommercePlatform: { $ref: "#/components/schemas/ExternalReferenceEcommercePlatform" }
	},
	required: [
		"source",
		"salesChannel",
		"ecommercePlatform"
	]
}, ve = {
	type: "object",
	properties: { source: {
		type: "string",
		enum: ["MYPARCEL_SHOP"]
	} },
	required: ["source"],
	description: "This external reference is set when the order originates from an \"etiketten\" shipment. The only actions allowed on this type of order is cancel"
}, ye = {
	type: "object",
	properties: {
		source: {
			type: "string",
			enum: ["IMPORT"]
		},
		sourceId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The order ID as defined in the source system."
		}
	},
	required: ["source", "sourceId"],
	description: "This external reference is set when the order originates from a generic ecommerce order import"
}, be = {
	oneOf: [
		{ $ref: "#/components/schemas/ExternalReferencesSalesChannel" },
		{ $ref: "#/components/schemas/ExternalReferencesMyParcelShop" },
		{ $ref: "#/components/schemas/ExternalReferencesImport" }
	],
	discriminator: {
		propertyName: "source",
		mapping: {
			SALES_CHANNEL: "#/components/schemas/ExternalReferencesSalesChannel",
			MYPARCEL_SHOP: "#/components/schemas/ExternalReferencesMyParcelShop",
			IMPORT: "#/components/schemas/ExternalReferencesImport"
		}
	}
}, xe = {
	type: "object",
	properties: { sourceId: {
		type: "string",
		minLength: 1,
		maxLength: 50,
		description: "The order line ID as defined in the source system."
	} },
	required: ["sourceId"],
	description: "The external reference of the order line."
}, Se = {
	type: "object",
	properties: {
		credited: {
			type: "boolean",
			description: "Whether the label is credited by us."
		},
		createdBy: {
			anyOf: [{
				type: "string",
				pattern: "^shop\\/.{1,250}$",
				description: "A shop principal identifier."
			}, {
				type: "string",
				pattern: "^user\\/.{1,250}$",
				description: "A user principal identifier."
			}],
			description: "Which principal created the label."
		},
		paymentStatus: { $ref: "#/components/schemas/PaymentStatus" },
		barcode: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The barcode of the label."
		},
		delayed: {
			type: "boolean",
			description: "Whether the shipment is delayed."
		},
		partnerBarcodes: {
			type: "array",
			items: {
				type: "string",
				minLength: 1,
				maxLength: 50,
				description: "The barcode identifier associated with the shipment label."
			},
			minItems: 1,
			maxItems: 5,
			description: "The partner barcodes when the parcel is taken over by a partner carrier."
		}
	},
	required: [
		"credited",
		"barcode",
		"delayed"
	]
}, Ce = {
	type: "object",
	properties: {
		credited: {
			type: "boolean",
			description: "Whether the label is credited by us."
		},
		createdBy: {
			anyOf: [{
				type: "string",
				pattern: "^shop\\/.{1,250}$",
				description: "A shop principal identifier."
			}, {
				type: "string",
				pattern: "^user\\/.{1,250}$",
				description: "A user principal identifier."
			}],
			description: "Which principal created the label."
		},
		paymentStatus: { $ref: "#/components/schemas/PaymentStatus" }
	},
	required: ["credited"]
}, we = {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["IMPORTED"]
		},
		id: {
			type: "string",
			format: "uuid",
			description: "The unique identifier of a note of an order."
		},
		notedAt: {
			anyOf: [{ type: "string" }, {
				type: "string",
				format: "date-time",
				description: "An ISO 8601 formatted datetime string with timezone offset."
			}],
			description: "The date and time the note was created."
		},
		origin: {
			type: "string",
			enum: ["SALES_CHANNEL"],
			description: "The origin of the note."
		},
		text: {
			type: "string",
			minLength: 1,
			maxLength: 2500,
			description: "The text of the note."
		},
		author: {
			type: "string",
			minLength: 1,
			maxLength: 200,
			description: "The author of the note."
		},
		locale: {
			anyOf: [{
				type: "string",
				minLength: 5,
				maxLength: 5,
				description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen."
			}, {
				type: "string",
				minLength: 2,
				maxLength: 2,
				description: "ISO 639-1 language code."
			}],
			description: "The locale of the note."
		},
		updatedAt: {
			anyOf: [{ type: "string" }, {
				type: "string",
				format: "date-time",
				description: "An ISO 8601 formatted datetime string with timezone offset."
			}],
			description: "The date and time the note was last updated."
		}
	},
	required: [
		"type",
		"id",
		"notedAt",
		"origin",
		"text"
	]
}, Te = {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["PRINCIPAL"]
		},
		id: {
			type: "string",
			format: "uuid",
			description: "The unique identifier of a note of an order."
		},
		notedAt: {
			anyOf: [{ type: "string" }, {
				type: "string",
				format: "date-time",
				description: "An ISO 8601 formatted datetime string with timezone offset."
			}],
			description: "The date and time the note was created."
		},
		principal: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The principal who crated the note."
		},
		text: {
			type: "string",
			minLength: 1,
			maxLength: 2500,
			description: "The text of the note."
		},
		locale: {
			anyOf: [{
				type: "string",
				minLength: 5,
				maxLength: 5,
				description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen."
			}, {
				type: "string",
				minLength: 2,
				maxLength: 2,
				description: "ISO 639-1 language code."
			}],
			description: "The locale of the note."
		},
		updatedAt: {
			anyOf: [{ type: "string" }, {
				type: "string",
				format: "date-time",
				description: "An ISO 8601 formatted datetime string with timezone offset."
			}],
			description: "The date and time the note was last updated."
		}
	},
	required: [
		"type",
		"id",
		"notedAt",
		"principal",
		"text"
	]
}, Ee = {
	oneOf: [{ $ref: "#/components/schemas/NoteFromImported" }, { $ref: "#/components/schemas/NoteFromPrincipal" }],
	discriminator: {
		propertyName: "type",
		mapping: {
			IMPORTED: "#/components/schemas/NoteFromImported",
			PRINCIPAL: "#/components/schemas/NoteFromPrincipal"
		}
	}
}, De = { anyOf: [
	{
		type: "object",
		properties: {
			address: { $ref: "#/components/schemas/Address" },
			location: {
				type: "object",
				properties: {
					name: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "The name of the pickup location."
					},
					code: {
						type: "string",
						minLength: 1,
						maxLength: 64,
						description: "The location code of the pickup location."
					},
					type: {
						type: "string",
						enum: [
							"CLICK_COLLECT",
							"PARCEL_LOCKER",
							"PARCEL_POINT",
							"POST_OFFICE",
							"POST_POINT"
						],
						description: "The bpost pickup location type."
					}
				},
				required: ["name", "type"],
				description: "The pickup location details."
			}
		},
		required: ["address", "location"],
		description: "The bpost pickup details."
	},
	{
		type: "object",
		properties: {
			address: { $ref: "#/components/schemas/Address" },
			location: {
				type: "object",
				properties: {
					name: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "The name of the pickup location."
					},
					code: {
						type: "string",
						minLength: 1,
						maxLength: 64,
						description: "The location code of the pickup location."
					}
				},
				required: ["name"],
				description: "The pickup location details."
			},
			retailNetworkId: {
				type: "string",
				enum: ["PNPNL-01", "PNPBE-01"],
				description: "PostNL Retail network ID."
			}
		},
		required: [
			"address",
			"location",
			"retailNetworkId"
		],
		description: "The PostNL pickup details."
	},
	{
		type: "object",
		properties: {
			address: { $ref: "#/components/schemas/Address" },
			location: {
				type: "object",
				properties: {
					name: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "The name of the pickup location."
					},
					code: {
						type: "string",
						minLength: 1,
						maxLength: 64,
						description: "The location code of the pickup location."
					}
				},
				required: ["name"],
				description: "The pickup location details."
			}
		},
		required: ["address", "location"],
		description: "The general pickup details."
	}
] }, Oe = {
	type: "object",
	properties: {
		carrier: { $ref: "#/components/schemas/Carrier" },
		direction: { $ref: "#/components/schemas/ShipmentDirection" },
		disableAutoDetectPickup: {
			type: "boolean",
			description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point."
		},
		packageType: { $ref: "#/components/schemas/PackageType" },
		recipient: {
			type: "object",
			properties: {
				address: { $ref: "#/components/schemas/Address" },
				contact: { $ref: "#/components/schemas/ContactMultiEmail" }
			},
			required: ["address", "contact"],
			description: "The recipient of the shipment."
		},
		customContractId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the contract."
		},
		delivery: { $ref: "#/components/schemas/Delivery" },
		options: { $ref: "#/components/schemas/ShipmentOptionsCommon" },
		pickup: { $ref: "#/components/schemas/Pickup" },
		sender: {
			type: "object",
			properties: {
				address: { $ref: "#/components/schemas/Address" },
				contact: { $ref: "#/components/schemas/Contact" }
			},
			required: ["address", "contact"],
			description: "The sender of the shipment."
		},
		saveRecipientAddress: {
			type: "boolean",
			description: "When set to true, the recipient address is saved to the user's address book."
		}
	},
	required: [
		"carrier",
		"direction",
		"disableAutoDetectPickup",
		"packageType",
		"recipient"
	]
}, ke = {
	type: "object",
	properties: {
		id: {
			type: "string",
			minLength: 1,
			description: "The unique identifier of the shipment."
		},
		carrier: { $ref: "#/components/schemas/Carrier" },
		createdAt: {
			anyOf: [{ type: "string" }, {
				type: "string",
				format: "date-time",
				description: "An ISO 8601 formatted datetime string with timezone offset."
			}],
			description: "The date when the shipment was created."
		},
		direction: { $ref: "#/components/schemas/ShipmentDirection" },
		hidden: {
			type: "boolean",
			description: "Whether the shipment is hidden."
		},
		packageType: { $ref: "#/components/schemas/PackageType" },
		recipient: {
			type: "object",
			properties: {
				address: { $ref: "#/components/schemas/Address" },
				contact: { $ref: "#/components/schemas/ContactMultiEmail" }
			},
			description: "The recipient of the shipment."
		},
		customContractId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the contract."
		},
		customsDeclaration: { $ref: "#/components/schemas/CustomsDeclarationResponse" },
		delivery: { $ref: "#/components/schemas/Delivery" },
		dropOff: { $ref: "#/components/schemas/DropOff" },
		label: {
			anyOf: [{ $ref: "#/components/schemas/LabelWithBarcode" }, { $ref: "#/components/schemas/LabelWithoutBarcode" }],
			description: "The label of the package."
		},
		multicollo: {
			type: "object",
			properties: {
				id: {
					type: "string",
					format: "uuid",
					description: "The unique identifier for a multicollo shipment group."
				},
				totalPackages: {
					type: "integer",
					minimum: 2,
					maximum: 20,
					description: "The total number of individual packages included within this specific multicollo shipment group."
				}
			},
			required: ["id", "totalPackages"],
			description: "Details if this package is part of a multi-package (multicollo) shipment. A multicollo shipment is a group of packages belonging to the same shipment that are consolidated for combined labeling and potential cost reduction. This object will only be present if the package is part of such a group."
		},
		options: { $ref: "#/components/schemas/ShipmentOptions" },
		pickup: { $ref: "#/components/schemas/Pickup" },
		price: { $ref: "#/components/schemas/Money" },
		sender: {
			type: "object",
			properties: {
				address: { $ref: "#/components/schemas/Address" },
				contact: { $ref: "#/components/schemas/Contact" }
			},
			required: ["address", "contact"],
			description: "The sender of the shipment."
		}
	},
	required: [
		"id",
		"carrier",
		"createdAt",
		"direction",
		"hidden",
		"packageType",
		"recipient"
	],
	description: "The shipment properties of a package."
}, Ae = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The unique identifier of a line of an order."
		},
		product: {
			type: "object",
			properties: {
				name: {
					type: "string",
					minLength: 1,
					maxLength: 250,
					description: "The name of the product."
				},
				ean: {
					type: "string",
					minLength: 1,
					maxLength: 13,
					description: "The EAN of the product."
				},
				sku: {
					type: "string",
					minLength: 1,
					maxLength: 200,
					description: "The SKU of the product."
				},
				id: {
					type: "string",
					format: "uuid",
					description: "Identifier of the product. This is always undefined when the `status` is `DISCOVERED` or `IMPORT_REQUESTED`, otherwise it is always defined."
				}
			},
			required: ["name"],
			description: "The product of an order line."
		},
		quantity: {
			type: "integer",
			minimum: 1,
			description: "The quantity of the product of the order line."
		},
		externalReference: { $ref: "#/components/schemas/LineExternalReference" },
		price: { allOf: [{ $ref: "#/components/schemas/Money" }, { description: "The price of the product of the order line." }] }
	},
	required: [
		"id",
		"product",
		"quantity"
	],
	description: "The line of the order"
}, je = {
	type: "object",
	properties: {
		customsDeclaration: { $ref: "#/components/schemas/CustomsDeclaration" },
		options: { $ref: "#/components/schemas/ShipmentOptionsPackage" },
		physicalProperties: { $ref: "#/components/schemas/PhysicalPropertiesWeightRequired" }
	}
}, Me = {
	type: "object",
	properties: {
		lines: {
			type: "array",
			items: {
				type: "object",
				properties: {
					id: {
						type: "string",
						format: "uuid",
						description: "The unique identifier of a line of an order."
					},
					quantity: {
						type: "integer",
						minimum: 1,
						description: "The quantity of the product of the order line."
					}
				},
				required: ["id", "quantity"]
			},
			minItems: 1,
			maxItems: 100
		},
		physicalProperties: { $ref: "#/components/schemas/PhysicalPropertiesWeightRequired" }
	}
}, Ne = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The unique identifier of the package."
		},
		status: { $ref: "#/components/schemas/PackageStatus" },
		physicalProperties: { $ref: "#/components/schemas/PhysicalProperties" },
		lines: {
			type: "array",
			items: {
				type: "object",
				properties: {
					id: {
						type: "string",
						format: "uuid",
						description: "The unique identifier of a line of an order."
					},
					quantity: {
						type: "integer",
						minimum: 1,
						description: "The quantity that the package contains"
					}
				},
				required: ["id", "quantity"]
			},
			minItems: 1,
			maxItems: 100,
			description: "The order lines related to the package."
		},
		shipment: { $ref: "#/components/schemas/Shipment" }
	},
	required: ["id", "status"]
}, Pe = {
	type: "object",
	properties: {
		customsDeclaration: { $ref: "#/components/schemas/CustomsDeclaration" },
		options: { $ref: "#/components/schemas/ShipmentOptionsPackage" },
		physicalProperties: { $ref: "#/components/schemas/PhysicalPropertiesWeightRequired" },
		shipment: {
			type: "object",
			properties: {
				carrier: { $ref: "#/components/schemas/CarrierToCreate" },
				direction: { $ref: "#/components/schemas/ShipmentDirection" },
				disableAutoDetectPickup: {
					type: "boolean",
					description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point."
				},
				packageType: { $ref: "#/components/schemas/PackageType" },
				recipient: {
					type: "object",
					properties: {
						address: { $ref: "#/components/schemas/Address" },
						contact: { $ref: "#/components/schemas/ContactMultiEmail" }
					},
					required: ["address", "contact"],
					description: "The recipient of the shipment."
				},
				customContractId: {
					type: "string",
					minLength: 1,
					maxLength: 50,
					description: "The unique identifier of the contract."
				},
				delivery: { $ref: "#/components/schemas/Delivery" },
				options: { $ref: "#/components/schemas/ShipmentOptionsCommon" },
				pickup: { $ref: "#/components/schemas/Pickup" },
				sender: {
					type: "object",
					properties: {
						address: { $ref: "#/components/schemas/Address" },
						contact: { $ref: "#/components/schemas/Contact" }
					},
					required: ["address", "contact"],
					description: "The sender of the shipment."
				},
				saveRecipientAddress: {
					type: "boolean",
					description: "When set to true, the recipient address is saved to the user's address book."
				}
			},
			required: [
				"carrier",
				"direction",
				"disableAutoDetectPickup",
				"packageType",
				"recipient"
			]
		}
	},
	required: ["shipment"]
}, Fe = {
	type: "object",
	properties: {
		carrier: { $ref: "#/components/schemas/Carrier" },
		customContractId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the contract."
		},
		customsDeclaration: { $ref: "#/components/schemas/CustomsDeclarationResponse" },
		delivery: { $ref: "#/components/schemas/Delivery" },
		direction: { $ref: "#/components/schemas/ShipmentDirection" },
		disableAutoDetectPickup: {
			type: "boolean",
			description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point."
		},
		numberOfLabels: {
			type: "integer",
			minimum: 1,
			maximum: 20
		},
		options: { $ref: "#/components/schemas/ShipmentOptions" },
		packageType: { $ref: "#/components/schemas/PackageType" },
		pickup: { $ref: "#/components/schemas/Pickup" },
		recipient: {
			type: "object",
			properties: {
				address: { $ref: "#/components/schemas/Address" },
				contact: { $ref: "#/components/schemas/ContactMultiEmail" }
			},
			description: "The recipient of the shipment."
		}
	},
	description: "The shipping preferences of the order. This should be used as default information when preparing packages for shipment."
}, Ie = { anyOf: [{
	type: "object",
	properties: {
		shopId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the shop."
		},
		customerReference: { $ref: "#/components/schemas/CustomerReference" },
		package: { $ref: "#/components/schemas/ShippablePackage" }
	},
	required: ["shopId", "package"]
}, {
	type: "object",
	properties: {
		shopId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the shop."
		},
		customerReference: { $ref: "#/components/schemas/CustomerReference" },
		multicollo: {
			type: "object",
			properties: {
				packages: {
					type: "array",
					items: { $ref: "#/components/schemas/PackageCommon" },
					minItems: 2,
					maxItems: 20
				},
				shipment: {
					type: "object",
					properties: {
						carrier: { $ref: "#/components/schemas/CarrierToCreate" },
						direction: { $ref: "#/components/schemas/ShipmentDirection" },
						disableAutoDetectPickup: {
							type: "boolean",
							description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point."
						},
						packageType: { $ref: "#/components/schemas/PackageType" },
						recipient: {
							type: "object",
							properties: {
								address: { $ref: "#/components/schemas/Address" },
								contact: { $ref: "#/components/schemas/ContactMultiEmail" }
							},
							required: ["address", "contact"],
							description: "The recipient of the shipment."
						},
						customContractId: {
							type: "string",
							minLength: 1,
							maxLength: 50,
							description: "The unique identifier of the contract."
						},
						delivery: { $ref: "#/components/schemas/Delivery" },
						options: { $ref: "#/components/schemas/ShipmentOptionsCommon" },
						pickup: { $ref: "#/components/schemas/Pickup" },
						sender: {
							type: "object",
							properties: {
								address: { $ref: "#/components/schemas/Address" },
								contact: { $ref: "#/components/schemas/Contact" }
							},
							required: ["address", "contact"],
							description: "The sender of the shipment."
						},
						saveRecipientAddress: {
							type: "boolean",
							description: "When set to true, the recipient address is saved to the user's address book."
						}
					},
					required: [
						"carrier",
						"direction",
						"disableAutoDetectPickup",
						"packageType",
						"recipient"
					]
				}
			},
			required: ["packages", "shipment"]
		}
	},
	required: ["shopId", "multicollo"]
}] }, Le = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The unique identifier of the order."
		},
		packages: {
			type: "array",
			items: { $ref: "#/components/schemas/PackageRequest" },
			minItems: 1,
			maxItems: 25
		}
	},
	required: ["id", "packages"]
}, Re = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The unique identifier of the package."
		},
		customsDeclaration: { $ref: "#/components/schemas/CustomsDeclaration" },
		options: { $ref: "#/components/schemas/ShipmentOptionsPackage" },
		physicalProperties: { $ref: "#/components/schemas/PhysicalPropertiesWeightRequired" }
	},
	required: ["id"]
}, ze = { anyOf: [{
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The unique identifier of the order."
		},
		shipment: { $ref: "#/components/schemas/ShipmentRequest" },
		packages: {
			type: "array",
			items: { $ref: "#/components/schemas/PreparePackagesForShipmentPackage" },
			minItems: 1,
			maxItems: 25
		}
	},
	required: [
		"id",
		"shipment",
		"packages"
	]
}, {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The unique identifier of the order."
		},
		shipment: { $ref: "#/components/schemas/ShipmentRequest" },
		multicollo: {
			type: "array",
			items: { $ref: "#/components/schemas/PreparePackagesForShipmentPackage" },
			minItems: 2,
			maxItems: 25
		}
	},
	required: [
		"id",
		"shipment",
		"multicollo"
	]
}] }, Be = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The unique identifier of the order."
		},
		orderedAt: {
			anyOf: [{ type: "string" }, {
				type: "string",
				format: "date-time",
				description: "An ISO 8601 formatted datetime string with timezone offset."
			}],
			description: "The date and time the order was placed."
		},
		price: { $ref: "#/components/schemas/Money" },
		shopId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the shop."
		},
		shortId: {
			type: "string",
			minLength: 9,
			maxLength: 9,
			description: "The short ID of the order."
		},
		status: { $ref: "#/components/schemas/OrderStatus" },
		assignedUserId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The user ID assigned to the order."
		},
		billingDetails: { $ref: "#/components/schemas/BillingDetails" },
		customerReference: { $ref: "#/components/schemas/CustomerReference" },
		externalReferences: { allOf: [{ $ref: "#/components/schemas/ExternalReferences" }, { description: "The external references of the order. These are read-only and automatically populated by the system based on the source." }] },
		lines: {
			type: "array",
			items: { $ref: "#/components/schemas/Line" },
			minItems: 1,
			maxItems: 100,
			description: "The lines of the order"
		},
		notes: {
			type: "array",
			items: { $ref: "#/components/schemas/Note" },
			minItems: 1,
			maxItems: 100,
			description: "The notes of the order."
		},
		packages: {
			type: "array",
			items: { $ref: "#/components/schemas/PackageResponse" },
			minItems: 1,
			maxItems: 25,
			description: "The packages of the order."
		},
		rules: {
			type: "object",
			properties: { setShippingPreferences: {
				type: "object",
				properties: {
					path: {
						type: "array",
						items: { anyOf: [{
							type: "object",
							properties: {
								id: {
									type: "string",
									format: "uuid",
									description: "The unique identifier of the rule."
								},
								name: {
									type: "string",
									description: "The name of the rule."
								}
							},
							required: ["id", "name"]
						}, {
							type: "object",
							properties: {
								id: {
									type: "string",
									format: "uuid",
									description: "The unique identifier of the rule group."
								},
								condition: { anyOf: [{
									type: "object",
									properties: { countryCode: { $ref: "#/components/schemas/CountryCode" } },
									required: ["countryCode"],
									additionalProperties: !1
								}, {
									type: "object",
									properties: { geoAreaCode: { $ref: "#/components/schemas/GeoAreaCode" } },
									required: ["geoAreaCode"],
									additionalProperties: !1
								}] }
							},
							required: ["id", "condition"]
						}] },
						minItems: 1,
						description: "The path of the rule."
					},
					appliedAt: {
						anyOf: [{ type: "string" }, {
							type: "string",
							format: "date-time",
							description: "An ISO 8601 formatted datetime string with timezone offset."
						}],
						description: "The date and time the rule was applied."
					},
					result: {
						type: "string",
						enum: ["PRESERVE", "REPLACE"],
						description: "How the rule was applied."
					}
				},
				required: [
					"path",
					"appliedAt",
					"result"
				]
			} },
			description: "The rules that have been applied to the order."
		},
		shipping: { $ref: "#/components/schemas/Shipping" }
	},
	required: [
		"id",
		"orderedAt",
		"price",
		"shopId",
		"shortId",
		"status"
	]
}, Ve = {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: [
				"about:blank",
				"urn:problem:client",
				"urn:problem:invalid-request-syntax",
				"urn:problem:not-found",
				"urn:problem:server",
				"urn:problem:unauthorized",
				"urn:problem:unsupported-media-type"
			],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "integer",
			enum: [
				400,
				401,
				404,
				415,
				500
			],
			description: "The HTTP status code generated by the origin server."
		},
		title: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "A short human-readable summary of the problem type."
		},
		detail: {
			type: "string",
			minLength: 1,
			maxLength: 5e3,
			description: "A human-readable explanation specific to this occurrence of the problem."
		},
		instance: {
			type: "string",
			format: "uri",
			description: "A URI reference that identifies the specific occurrence of the problem."
		},
		cause: { description: "The cause of this problem when debug mode is enabled." }
	},
	required: [
		"type",
		"status",
		"title",
		"detail",
		"instance"
	]
}, He = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:client"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [400],
			description: "The HTTP status code generated by the origin server."
		},
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					detail: {
						type: "string",
						minLength: 1,
						maxLength: 5e3
					},
					pointer: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)."
					}
				},
				required: ["detail", "pointer"]
			},
			minItems: 1,
			description: "Detailed information regarding the violations."
		}
	},
	required: ["errors"]
}] }, Ue = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:server"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [500],
			description: "The HTTP status code generated by the origin server."
		}
	}
}] }, We = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:invalid-request-syntax"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [400],
			description: "The HTTP status code generated by the origin server."
		},
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					detail: {
						type: "string",
						minLength: 1,
						maxLength: 5e3
					},
					pointer: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)."
					}
				},
				required: ["detail", "pointer"]
			},
			minItems: 1,
			description: "Detailed information regarding the syntactic violations."
		}
	},
	required: ["errors"]
}] }, Ge = {
	BPOST: "BPOST",
	BRT: "BRT",
	CHEAP_CARGO: "CHEAP_CARGO",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DPD: "DPD",
	GLS: "GLS",
	INPOST: "INPOST",
	POSTNL: "POSTNL",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	TRUNKRS: "TRUNKRS",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	UPS_STANDARD: "UPS_STANDARD",
	VIA_TIM: "VIA_TIM",
	BOL: "BOL"
}, Ke = {
	BPOST: "BPOST",
	BRT: "BRT",
	CHEAP_CARGO: "CHEAP_CARGO",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DPD: "DPD",
	GLS: "GLS",
	INPOST: "INPOST",
	POSTNL: "POSTNL",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	TRUNKRS: "TRUNKRS",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	UPS_STANDARD: "UPS_STANDARD",
	VIA_TIM: "VIA_TIM"
}, qe = {
	EARLY_MORNING_DELIVERY: "EARLY_MORNING_DELIVERY",
	EVENING_DELIVERY: "EVENING_DELIVERY",
	EXPRESS_DELIVERY: "EXPRESS_DELIVERY",
	MORNING_DELIVERY: "MORNING_DELIVERY",
	PICKUP_EXPRESS_DELIVERY: "PICKUP_EXPRESS_DELIVERY",
	PICKUP_DELIVERY: "PICKUP_DELIVERY",
	SAME_DAY_DELIVERY: "SAME_DAY_DELIVERY",
	STANDARD_DELIVERY: "STANDARD_DELIVERY"
}, Je = {
	EU: "EU",
	NON_EU: "NON_EU"
}, Ye = {
	CANCELED: "CANCELED",
	COMPLETED: "COMPLETED",
	DISCOVERED: "DISCOVERED",
	IMPORT_REQUESTED: "IMPORT_REQUESTED",
	OPEN: "OPEN",
	PROCESSING: "PROCESSING",
	RETURNING: "RETURNING"
}, Xe = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
}, Ze = {
	PAID: "PAID",
	PENDING: "PENDING",
	UNPAID: "UNPAID"
}, Qe = {
	OUTBOUND: "OUTBOUND",
	INBOUND: "INBOUND"
}, $e = {
	ASC: "ASC",
	DESC: "DESC"
}, et = {
	SalesChannelStatusChanged: "SalesChannelStatusChanged",
	ProductCreated: "ProductCreated",
	ProductUpdated: "ProductUpdated",
	OrderCreated: "OrderCreated",
	OrderDeleted: "OrderDeleted",
	OrderRulesEvaluated: "OrderRulesEvaluated",
	OrderUpdated: "OrderUpdated",
	Printed: "Printed",
	PrintErrored: "PrintErrored"
}, tt = {
	Account: "account",
	Shop: "shop",
	Order: "ORDER",
	Product: "PRODUCT",
	Print: "PRINT"
}, nt = {
	Event: "Event",
	Order: "Order",
	Printing: "Printing",
	Product: "Product"
};
//#endregion
//#region ../../node_modules/.pnpm/@vue+shared@3.5.40/node_modules/@vue/shared/dist/shared.esm-bundler.js
// @__NO_SIDE_EFFECTS__
function rt(e) {
	let t = /* @__PURE__ */ Object.create(null);
	for (let n of e.split(",")) t[n] = 1;
	return (e) => e in t;
}
var _ = process.env.NODE_ENV === "production" ? {} : Object.freeze({});
process.env.NODE_ENV === "production" || Object.freeze([]);
var v = () => {}, it = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && (e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), at = (e) => e.startsWith("onUpdate:"), y = Object.assign, ot = (e, t) => {
	let n = e.indexOf(t);
	n > -1 && e.splice(n, 1);
}, st = Object.prototype.hasOwnProperty, b = (e, t) => st.call(e, t), x = Array.isArray, S = (e) => ft(e) === "[object Map]", ct = (e) => ft(e) === "[object Set]", C = (e) => typeof e == "function", w = (e) => typeof e == "string", lt = (e) => typeof e == "symbol", T = (e) => typeof e == "object" && !!e, ut = (e) => (T(e) || C(e)) && C(e.then) && C(e.catch), dt = Object.prototype.toString, ft = (e) => dt.call(e), pt = (e) => ft(e).slice(8, -1), mt = (e) => ft(e) === "[object Object]", ht = (e) => w(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, gt = ((e) => {
	let t = /* @__PURE__ */ Object.create(null);
	return ((n) => t[n] || (t[n] = e(n)));
})((e) => e.charAt(0).toUpperCase() + e.slice(1)), E = (e, t) => !Object.is(e, t), _t = (e, t, n, r = !1) => {
	Object.defineProperty(e, t, {
		configurable: !0,
		enumerable: !1,
		writable: r,
		value: n
	});
}, vt, yt = () => vt ||= typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
function bt(e) {
	if (x(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) {
			let r = e[n], i = w(r) ? wt(r) : bt(r);
			if (i) for (let e in i) t[e] = i[e];
		}
		return t;
	} else if (w(e) || T(e)) return e;
}
var xt = /;(?![^(]*\))/g, St = /:([^]+)/, Ct = /\/\*[^]*?\*\//g;
function wt(e) {
	let t = {};
	return e.replace(Ct, "").split(xt).forEach((e) => {
		if (e) {
			let n = e.split(St);
			n.length > 1 && (t[n[0].trim()] = n[1].trim());
		}
	}), t;
}
function Tt(e) {
	let t = "";
	if (w(e)) t = e;
	else if (x(e)) for (let n = 0; n < e.length; n++) {
		let r = Tt(e[n]);
		r && (t += r + " ");
	}
	else if (T(e)) for (let n in e) e[n] && (t += n + " ");
	return t.trim();
}
//#endregion
//#region ../../node_modules/.pnpm/@vue+reactivity@3.5.40/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
function D(e, ...t) {
	console.warn(`[Vue warn] ${e}`, ...t);
}
var Et;
function Dt() {
	return Et;
}
var O, Ot = /* @__PURE__ */ new WeakSet(), kt = class {
	constructor(e) {
		this.fn = e, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, Et && (Et.active ? Et.effects.push(this) : this.flags &= -2);
	}
	pause() {
		this.flags |= 64;
	}
	resume() {
		this.flags & 64 && (this.flags &= -65, Ot.has(this) && (Ot.delete(this), this.trigger()));
	}
	notify() {
		this.flags & 2 && !(this.flags & 32) || this.flags & 8 || Nt(this);
	}
	run() {
		if (!(this.flags & 1)) return this.fn();
		this.flags |= 2, Gt(this), It(this);
		let e = O, t = k;
		O = this, k = !0;
		try {
			return this.fn();
		} finally {
			process.env.NODE_ENV !== "production" && O !== this && D("Active effect was not restored correctly - this is likely a Vue internal bug."), Lt(this), O = e, k = t, this.flags &= -3;
		}
	}
	stop() {
		if (this.flags & 1) {
			for (let e = this.deps; e; e = e.nextDep) Bt(e);
			this.deps = this.depsTail = void 0, Gt(this), this.onStop && this.onStop(), this.flags &= -2;
		}
	}
	trigger() {
		this.flags & 64 ? Ot.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
	}
	runIfDirty() {
		Rt(this) && this.run();
	}
	get dirty() {
		return Rt(this);
	}
}, At = 0, jt, Mt;
function Nt(e, t = !1) {
	if (e.flags |= 8, t) {
		e.next = Mt, Mt = e;
		return;
	}
	e.next = jt, jt = e;
}
function Pt() {
	At++;
}
function Ft() {
	if (--At > 0) return;
	if (Mt) {
		let e = Mt;
		for (Mt = void 0; e;) {
			let t = e.next;
			e.next = void 0, e.flags &= -9, e = t;
		}
	}
	let e;
	for (; jt;) {
		let t = jt;
		for (jt = void 0; t;) {
			let n = t.next;
			if (t.next = void 0, t.flags &= -9, t.flags & 1) try {
				t.trigger();
			} catch (t) {
				e ||= t;
			}
			t = n;
		}
	}
	if (e) throw e;
}
function It(e) {
	for (let t = e.deps; t; t = t.nextDep) t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function Lt(e) {
	let t, n = e.depsTail, r = n;
	for (; r;) {
		let e = r.prevDep;
		r.version === -1 ? (r === n && (n = e), Bt(r), Vt(r)) : t = r, r.dep.activeLink = r.prevActiveLink, r.prevActiveLink = void 0, r = e;
	}
	e.deps = t, e.depsTail = n;
}
function Rt(e) {
	for (let t = e.deps; t; t = t.nextDep) if (t.dep.version !== t.version || t.dep.computed && (zt(t.dep.computed) || t.dep.version !== t.version)) return !0;
	return !!e._dirty;
}
function zt(e) {
	if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === Kt) || (e.globalVersion = Kt, !e.isSSR && e.flags & 128 && (!e.deps && !e._dirty || !Rt(e)))) return;
	e.flags |= 2;
	let t = e.dep, n = O, r = k;
	O = e, k = !0;
	try {
		It(e);
		let n = e.fn(e._value);
		(t.version === 0 || E(n, e._value)) && (e.flags |= 128, e._value = n, t.version++);
	} catch (e) {
		throw t.version++, e;
	} finally {
		O = n, k = r, Lt(e), e.flags &= -3;
	}
}
function Bt(e, t = !1) {
	let { dep: n, prevSub: r, nextSub: i } = e;
	if (r && (r.nextSub = i, e.prevSub = void 0), i && (i.prevSub = r, e.nextSub = void 0), process.env.NODE_ENV !== "production" && n.subsHead === e && (n.subsHead = i), n.subs === e && (n.subs = r, !r && n.computed)) {
		n.computed.flags &= -5;
		for (let e = n.computed.deps; e; e = e.nextDep) Bt(e, !0);
	}
	!t && !--n.sc && n.map && n.map.delete(n.key);
}
function Vt(e) {
	let { prevDep: t, nextDep: n } = e;
	t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
var k = !0, Ht = [];
function Ut() {
	Ht.push(k), k = !1;
}
function Wt() {
	let e = Ht.pop();
	k = e === void 0 || e;
}
function Gt(e) {
	let { cleanup: t } = e;
	if (e.cleanup = void 0, t) {
		let e = O;
		O = void 0;
		try {
			t();
		} finally {
			O = e;
		}
	}
}
var Kt = 0, qt = class {
	constructor(e, t) {
		this.sub = e, this.dep = t, this.version = t.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
	}
}, Jt = class {
	constructor(e) {
		this.computed = e, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
	}
	track(e) {
		if (!O || !k || O === this.computed) return;
		let t = this.activeLink;
		if (t === void 0 || t.sub !== O) t = this.activeLink = new qt(O, this), O.deps ? (t.prevDep = O.depsTail, O.depsTail.nextDep = t, O.depsTail = t) : O.deps = O.depsTail = t, Yt(t);
		else if (t.version === -1 && (t.version = this.version, t.nextDep)) {
			let e = t.nextDep;
			e.prevDep = t.prevDep, t.prevDep && (t.prevDep.nextDep = e), t.prevDep = O.depsTail, t.nextDep = void 0, O.depsTail.nextDep = t, O.depsTail = t, O.deps === t && (O.deps = e);
		}
		return process.env.NODE_ENV !== "production" && O.onTrack && O.onTrack(y({ effect: O }, e)), t;
	}
	trigger(e) {
		this.version++, Kt++, this.notify(e);
	}
	notify(e) {
		Pt();
		try {
			if (process.env.NODE_ENV !== "production") for (let t = this.subsHead; t; t = t.nextSub) t.sub.onTrigger && !(t.sub.flags & 8) && t.sub.onTrigger(y({ effect: t.sub }, e));
			for (let e = this.subs; e; e = e.prevSub) e.sub.notify() && e.sub.dep.notify();
		} finally {
			Ft();
		}
	}
};
function Yt(e) {
	if (e.dep.sc++, e.sub.flags & 4) {
		let t = e.dep.computed;
		if (t && !e.dep.subs) {
			t.flags |= 20;
			for (let e = t.deps; e; e = e.nextDep) Yt(e);
		}
		let n = e.dep.subs;
		n !== e && (e.prevSub = n, n && (n.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
	}
}
var Xt = /* @__PURE__ */ new WeakMap(), A = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Object iterate"), Zt = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Map keys iterate"), j = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Array iterate");
function M(e, t, n) {
	if (k && O) {
		let r = Xt.get(e);
		r || Xt.set(e, r = /* @__PURE__ */ new Map());
		let i = r.get(n);
		i || (r.set(n, i = new Jt()), i.map = r, i.key = n), process.env.NODE_ENV === "production" ? i.track() : i.track({
			target: e,
			type: t,
			key: n
		});
	}
}
function N(e, t, n, r, i, a) {
	let o = Xt.get(e);
	if (!o) {
		Kt++;
		return;
	}
	let s = (o) => {
		o && (process.env.NODE_ENV === "production" ? o.trigger() : o.trigger({
			target: e,
			type: t,
			key: n,
			newValue: r,
			oldValue: i,
			oldTarget: a
		}));
	};
	if (Pt(), t === "clear") o.forEach(s);
	else {
		let i = x(e), a = i && ht(n);
		if (i && n === "length") {
			let e = Number(r);
			o.forEach((t, n) => {
				(n === "length" || n === j || !lt(n) && n >= e) && s(t);
			});
		} else switch ((n !== void 0 || o.has(void 0)) && s(o.get(n)), a && s(o.get(j)), t) {
			case "add":
				i ? a && s(o.get("length")) : (s(o.get(A)), S(e) && s(o.get(Zt)));
				break;
			case "delete":
				i || (s(o.get(A)), S(e) && s(o.get(Zt)));
				break;
			case "set":
				S(e) && s(o.get(A));
				break;
		}
	}
	Ft();
}
function P(e) {
	let t = /* @__PURE__ */ B(e);
	return t === e ? t : (M(t, "iterate", j), /* @__PURE__ */ z(e) ? t : t.map(V));
}
function Qt(e) {
	return M(e = /* @__PURE__ */ B(e), "iterate", j), e;
}
function F(e, t) {
	return /* @__PURE__ */ R(e) ? In(/* @__PURE__ */ L(e) ? V(t) : t) : V(t);
}
var $t = {
	__proto__: null,
	[Symbol.iterator]() {
		return en(this, Symbol.iterator, (e) => F(this, e));
	},
	concat(...e) {
		return P(this).concat(...e.map((e) => x(e) ? P(e) : e));
	},
	entries() {
		return en(this, "entries", (e) => (e[1] = F(this, e[1]), e));
	},
	every(e, t) {
		return I(this, "every", e, t, void 0, arguments);
	},
	filter(e, t) {
		return I(this, "filter", e, t, (e) => e.map((e) => F(this, e)), arguments);
	},
	find(e, t) {
		return I(this, "find", e, t, (e) => F(this, e), arguments);
	},
	findIndex(e, t) {
		return I(this, "findIndex", e, t, void 0, arguments);
	},
	findLast(e, t) {
		return I(this, "findLast", e, t, (e) => F(this, e), arguments);
	},
	findLastIndex(e, t) {
		return I(this, "findLastIndex", e, t, void 0, arguments);
	},
	forEach(e, t) {
		return I(this, "forEach", e, t, void 0, arguments);
	},
	includes(...e) {
		return rn(this, "includes", e);
	},
	indexOf(...e) {
		return rn(this, "indexOf", e);
	},
	join(e) {
		return P(this).join(e);
	},
	lastIndexOf(...e) {
		return rn(this, "lastIndexOf", e);
	},
	map(e, t) {
		return I(this, "map", e, t, void 0, arguments);
	},
	pop() {
		return an(this, "pop");
	},
	push(...e) {
		return an(this, "push", e);
	},
	reduce(e, ...t) {
		return nn(this, "reduce", e, t);
	},
	reduceRight(e, ...t) {
		return nn(this, "reduceRight", e, t);
	},
	shift() {
		return an(this, "shift");
	},
	some(e, t) {
		return I(this, "some", e, t, void 0, arguments);
	},
	splice(...e) {
		return an(this, "splice", e);
	},
	toReversed() {
		return P(this).toReversed();
	},
	toSorted(e) {
		return P(this).toSorted(e);
	},
	toSpliced(...e) {
		return P(this).toSpliced(...e);
	},
	unshift(...e) {
		return an(this, "unshift", e);
	},
	values() {
		return en(this, "values", (e) => F(this, e));
	}
};
function en(e, t, n) {
	let r = Qt(e), i = r[t]();
	return r !== e && !/* @__PURE__ */ z(e) && (i._next = i.next, i.next = () => {
		let e = i._next();
		return e.done || (e.value = n(e.value)), e;
	}), i;
}
var tn = Array.prototype;
function I(e, t, n, r, i, a) {
	let o = Qt(e), s = o !== e && !/* @__PURE__ */ z(e), c = o[t];
	if (c !== tn[t]) {
		let t = c.apply(e, a);
		return s ? V(t) : t;
	}
	let l = n;
	o !== e && (s ? l = function(t, r) {
		return n.call(this, F(e, t), r, e);
	} : n.length > 2 && (l = function(t, r) {
		return n.call(this, t, r, e);
	}));
	let u = c.call(o, l, r);
	return s && i ? i(u) : u;
}
function nn(e, t, n, r) {
	let i = Qt(e), a = i !== e && !/* @__PURE__ */ z(e), o = n, s = !1;
	i !== e && (a ? (s = r.length === 0, o = function(t, r, i) {
		return s && (s = !1, t = F(e, t)), n.call(this, t, F(e, r), i, e);
	}) : n.length > 3 && (o = function(t, r, i) {
		return n.call(this, t, r, i, e);
	}));
	let c = i[t](o, ...r);
	return s ? F(e, c) : c;
}
function rn(e, t, n) {
	let r = /* @__PURE__ */ B(e);
	M(r, "iterate", j);
	let i = r[t](...n);
	return (i === -1 || i === !1) && /* @__PURE__ */ Pn(n[0]) ? (n[0] = /* @__PURE__ */ B(n[0]), r[t](...n)) : i;
}
function an(e, t, n = []) {
	Ut(), Pt();
	let r = (/* @__PURE__ */ B(e))[t].apply(e, n);
	return Ft(), Wt(), r;
}
var on = /* @__PURE__ */ rt("__proto__,__v_isRef,__isVue"), sn = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(lt));
function cn(e) {
	lt(e) || (e = String(e));
	let t = /* @__PURE__ */ B(this);
	return M(t, "has", e), t.hasOwnProperty(e);
}
var ln = class {
	constructor(e = !1, t = !1) {
		this._isReadonly = e, this._isShallow = t;
	}
	get(e, t, n) {
		if (t === "__v_skip") return e.__v_skip;
		let r = this._isReadonly, i = this._isShallow;
		if (t === "__v_isReactive") return !r;
		if (t === "__v_isReadonly") return r;
		if (t === "__v_isShallow") return i;
		if (t === "__v_raw") return n === (r ? i ? On : Dn : i ? En : Tn).get(e) || Object.getPrototypeOf(e) === Object.getPrototypeOf(n) ? e : void 0;
		let a = x(e);
		if (!r) {
			let e;
			if (a && (e = $t[t])) return e;
			if (t === "hasOwnProperty") return cn;
		}
		let o = Reflect.get(e, t, /* @__PURE__ */ H(e) ? e : n);
		if ((lt(t) ? sn.has(t) : on(t)) || (r || M(e, "get", t), i)) return o;
		if (/* @__PURE__ */ H(o)) {
			let e = a && ht(t) ? o : o.value;
			return r && T(e) ? /* @__PURE__ */ jn(e) : e;
		}
		return T(o) ? r ? /* @__PURE__ */ jn(o) : /* @__PURE__ */ An(o) : o;
	}
}, un = class extends ln {
	constructor(e = !1) {
		super(!1, e);
	}
	set(e, t, n, r) {
		let i = e[t], a = x(e) && ht(t);
		if (!this._isShallow) {
			let r = /* @__PURE__ */ R(i);
			if (!/* @__PURE__ */ z(n) && !/* @__PURE__ */ R(n) && (i = /* @__PURE__ */ B(i), n = /* @__PURE__ */ B(n)), !a && /* @__PURE__ */ H(i) && !/* @__PURE__ */ H(n)) return r ? (process.env.NODE_ENV !== "production" && D(`Set operation on key "${String(t)}" failed: target is readonly.`, e[t]), !0) : (i.value = n, !0);
		}
		let o = a ? Number(t) < e.length : b(e, t), s = Reflect.set(e, t, n, /* @__PURE__ */ H(e) ? e : r);
		return e === /* @__PURE__ */ B(r) && s && (o ? E(n, i) && N(e, "set", t, n, i) : N(e, "add", t, n)), s;
	}
	deleteProperty(e, t) {
		let n = b(e, t), r = e[t], i = Reflect.deleteProperty(e, t);
		return i && n && N(e, "delete", t, void 0, r), i;
	}
	has(e, t) {
		let n = Reflect.has(e, t);
		return (!lt(t) || !sn.has(t)) && M(e, "has", t), n;
	}
	ownKeys(e) {
		return M(e, "iterate", x(e) ? "length" : A), Reflect.ownKeys(e);
	}
}, dn = class extends ln {
	constructor(e = !1) {
		super(!0, e);
	}
	set(e, t) {
		return process.env.NODE_ENV !== "production" && D(`Set operation on key "${String(t)}" failed: target is readonly.`, e), !0;
	}
	deleteProperty(e, t) {
		return process.env.NODE_ENV !== "production" && D(`Delete operation on key "${String(t)}" failed: target is readonly.`, e), !0;
	}
}, fn = /* @__PURE__ */ new un(), pn = /* @__PURE__ */ new dn(), mn = /* @__PURE__ */ new dn(!0), hn = (e) => e, gn = (e) => Reflect.getPrototypeOf(e);
function _n(e, t, n) {
	return function(...r) {
		let i = this.__v_raw, a = /* @__PURE__ */ B(i), o = S(a), s = e === "entries" || e === Symbol.iterator && o, c = e === "keys" && o, l = i[e](...r), u = n ? hn : t ? In : V;
		return !t && M(a, "iterate", c ? Zt : A), y(Object.create(l), { next() {
			let { value: e, done: t } = l.next();
			return t ? {
				value: e,
				done: t
			} : {
				value: s ? [u(e[0]), u(e[1])] : u(e),
				done: t
			};
		} });
	};
}
function vn(e) {
	return function(...t) {
		if (process.env.NODE_ENV !== "production") {
			let n = t[0] ? `on key "${t[0]}" ` : "";
			D(`${gt(e)} operation ${n}failed: target is readonly.`, /* @__PURE__ */ B(this));
		}
		return e === "delete" ? !1 : e === "clear" ? void 0 : this;
	};
}
function yn(e, t) {
	let n = {
		get(n) {
			let r = this.__v_raw, i = /* @__PURE__ */ B(r), a = /* @__PURE__ */ B(n);
			e || (E(n, a) && M(i, "get", n), M(i, "get", a));
			let { has: o } = gn(i), s = t ? hn : e ? In : V;
			if (o.call(i, n)) return s(r.get(n));
			if (o.call(i, a)) return s(r.get(a));
			r !== i && r.get(n);
		},
		get size() {
			let t = this.__v_raw;
			return !e && M(/* @__PURE__ */ B(t), "iterate", A), t.size;
		},
		has(t) {
			let n = this.__v_raw, r = /* @__PURE__ */ B(n), i = /* @__PURE__ */ B(t);
			return e || (E(t, i) && M(r, "has", t), M(r, "has", i)), t === i ? n.has(t) : n.has(t) || n.has(i);
		},
		forEach(n, r) {
			let i = this, a = i.__v_raw, o = /* @__PURE__ */ B(a), s = t ? hn : e ? In : V;
			return !e && M(o, "iterate", A), a.forEach((e, t) => n.call(r, s(e), s(t), i));
		}
	};
	return y(n, e ? {
		add: vn("add"),
		set: vn("set"),
		delete: vn("delete"),
		clear: vn("clear")
	} : {
		add(e) {
			let n = /* @__PURE__ */ B(this), r = gn(n), i = /* @__PURE__ */ B(e), a = !t && !/* @__PURE__ */ z(e) && !/* @__PURE__ */ R(e) ? i : e;
			return r.has.call(n, a) || E(e, a) && r.has.call(n, e) || E(i, a) && r.has.call(n, i) || (n.add(a), N(n, "add", a, a)), this;
		},
		set(e, n) {
			!t && !/* @__PURE__ */ z(n) && !/* @__PURE__ */ R(n) && (n = /* @__PURE__ */ B(n));
			let r = /* @__PURE__ */ B(this), { has: i, get: a } = gn(r), o = i.call(r, e);
			o ? process.env.NODE_ENV !== "production" && wn(r, i, e) : (e = /* @__PURE__ */ B(e), o = i.call(r, e));
			let s = a.call(r, e);
			return r.set(e, n), o ? E(n, s) && N(r, "set", e, n, s) : N(r, "add", e, n), this;
		},
		delete(e) {
			let t = /* @__PURE__ */ B(this), { has: n, get: r } = gn(t), i = n.call(t, e);
			i ? process.env.NODE_ENV !== "production" && wn(t, n, e) : (e = /* @__PURE__ */ B(e), i = n.call(t, e));
			let a = r ? r.call(t, e) : void 0, o = t.delete(e);
			return i && N(t, "delete", e, void 0, a), o;
		},
		clear() {
			let e = /* @__PURE__ */ B(this), t = e.size !== 0, n = process.env.NODE_ENV === "production" ? void 0 : S(e) ? new Map(e) : new Set(e), r = e.clear();
			return t && N(e, "clear", void 0, void 0, n), r;
		}
	}), [
		"keys",
		"values",
		"entries",
		Symbol.iterator
	].forEach((r) => {
		n[r] = _n(r, e, t);
	}), n;
}
function bn(e, t) {
	let n = yn(e, t);
	return (t, r, i) => r === "__v_isReactive" ? !e : r === "__v_isReadonly" ? e : r === "__v_raw" ? t : Reflect.get(b(n, r) && r in t ? n : t, r, i);
}
var xn = { get: /* @__PURE__ */ bn(!1, !1) }, Sn = { get: /* @__PURE__ */ bn(!0, !1) }, Cn = { get: /* @__PURE__ */ bn(!0, !0) };
function wn(e, t, n) {
	let r = /* @__PURE__ */ B(n);
	if (r !== n && t.call(e, r)) {
		let t = pt(e);
		D(`Reactive ${t} contains both the raw and reactive versions of the same object${t === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
	}
}
var Tn = /* @__PURE__ */ new WeakMap(), En = /* @__PURE__ */ new WeakMap(), Dn = /* @__PURE__ */ new WeakMap(), On = /* @__PURE__ */ new WeakMap();
function kn(e) {
	switch (e) {
		case "Object":
		case "Array": return 1;
		case "Map":
		case "Set":
		case "WeakMap":
		case "WeakSet": return 2;
		default: return 0;
	}
}
// @__NO_SIDE_EFFECTS__
function An(e) {
	return /* @__PURE__ */ R(e) ? e : Nn(e, !1, fn, xn, Tn);
}
// @__NO_SIDE_EFFECTS__
function jn(e) {
	return Nn(e, !0, pn, Sn, Dn);
}
// @__NO_SIDE_EFFECTS__
function Mn(e) {
	return Nn(e, !0, mn, Cn, On);
}
function Nn(e, t, n, r, i) {
	if (!T(e)) return process.env.NODE_ENV !== "production" && D(`value cannot be made ${t ? "readonly" : "reactive"}: ${String(e)}`), e;
	if (e.__v_raw && !(t && e.__v_isReactive) || e.__v_skip || !Object.isExtensible(e)) return e;
	let a = i.get(e);
	if (a) return a;
	let o = kn(pt(e));
	if (o === 0) return e;
	let s = new Proxy(e, o === 2 ? r : n);
	return i.set(e, s), s;
}
// @__NO_SIDE_EFFECTS__
function L(e) {
	return /* @__PURE__ */ R(e) ? /* @__PURE__ */ L(e.__v_raw) : !!(e && e.__v_isReactive);
}
// @__NO_SIDE_EFFECTS__
function R(e) {
	return !!(e && e.__v_isReadonly);
}
// @__NO_SIDE_EFFECTS__
function z(e) {
	return !!(e && e.__v_isShallow);
}
// @__NO_SIDE_EFFECTS__
function Pn(e) {
	return e ? !!e.__v_raw : !1;
}
// @__NO_SIDE_EFFECTS__
function B(e) {
	let t = e && e.__v_raw;
	return t ? /* @__PURE__ */ B(t) : e;
}
function Fn(e) {
	return !b(e, "__v_skip") && Object.isExtensible(e) && _t(e, "__v_skip", !0), e;
}
var V = (e) => T(e) ? /* @__PURE__ */ An(e) : e, In = (e) => T(e) ? /* @__PURE__ */ jn(e) : e;
// @__NO_SIDE_EFFECTS__
function H(e) {
	return e ? e.__v_isRef === !0 : !1;
}
function Ln(e) {
	return /* @__PURE__ */ H(e) ? e.value : e;
}
var Rn = {
	get: (e, t, n) => t === "__v_raw" ? e : Ln(Reflect.get(e, t, n)),
	set: (e, t, n, r) => {
		let i = e[t];
		return /* @__PURE__ */ H(i) && !/* @__PURE__ */ H(n) ? (i.value = n, !0) : Reflect.set(e, t, n, r);
	}
};
function zn(e) {
	return /* @__PURE__ */ L(e) ? e : new Proxy(e, Rn);
}
var Bn = {}, Vn = /* @__PURE__ */ new WeakMap(), U = void 0;
function Hn(e, t = !1, n = U) {
	if (n) {
		let t = Vn.get(n);
		t || Vn.set(n, t = []), t.push(e);
	} else process.env.NODE_ENV !== "production" && !t && D("onWatcherCleanup() was called when there was no active watcher to associate with.");
}
function Un(e, t, n = _) {
	let { immediate: r, deep: i, once: a, scheduler: o, augmentJob: s, call: c } = n, l = (e) => {
		(n.onWarn || D)("Invalid watch source: ", e, "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.");
	}, u = (e) => i ? e : /* @__PURE__ */ z(e) || i === !1 || i === 0 ? W(e, 1) : W(e), d, f, p, ee, te = !1, ne = !1;
	if (/* @__PURE__ */ H(e) ? (f = () => e.value, te = /* @__PURE__ */ z(e)) : /* @__PURE__ */ L(e) ? (f = () => u(e), te = !0) : x(e) ? (ne = !0, te = e.some((e) => /* @__PURE__ */ L(e) || /* @__PURE__ */ z(e)), f = () => e.map((e) => {
		if (/* @__PURE__ */ H(e)) return e.value;
		if (/* @__PURE__ */ L(e)) return u(e);
		if (C(e)) return c ? c(e, 2) : e();
		process.env.NODE_ENV !== "production" && l(e);
	})) : C(e) ? f = t ? c ? () => c(e, 2) : e : () => {
		if (p) {
			Ut();
			try {
				p();
			} finally {
				Wt();
			}
		}
		let t = U;
		U = d;
		try {
			return c ? c(e, 3, [ee]) : e(ee);
		} finally {
			U = t;
		}
	} : (f = v, process.env.NODE_ENV !== "production" && l(e)), t && i) {
		let e = f, t = i === !0 ? Infinity : i;
		f = () => W(e(), t);
	}
	let re = Dt(), m = () => {
		d.stop(), re && re.active && ot(re.effects, d);
	};
	if (a && t) {
		let e = t;
		t = (...t) => {
			let n = e(...t);
			return m(), n;
		};
	}
	let h = ne ? Array(e.length).fill(Bn) : Bn, g = (e) => {
		if (!(!(d.flags & 1) || !d.dirty && !e)) if (t) {
			let n = d.run();
			if (e || i || te || (ne ? n.some((e, t) => E(e, h[t])) : E(n, h))) {
				p && p();
				let e = U;
				U = d;
				try {
					let e = [
						n,
						h === Bn ? void 0 : ne && h[0] === Bn ? [] : h,
						ee
					];
					h = n, c ? c(t, 3, e) : t(...e);
				} finally {
					U = e;
				}
			}
		} else d.run();
	};
	return s && s(g), d = new kt(f), d.scheduler = o ? () => o(g, !1) : g, ee = (e) => Hn(e, !1, d), p = d.onStop = () => {
		let e = Vn.get(d);
		if (e) {
			if (c) c(e, 4);
			else for (let t of e) t();
			Vn.delete(d);
		}
	}, process.env.NODE_ENV !== "production" && (d.onTrack = n.onTrack, d.onTrigger = n.onTrigger), t ? r ? g(!0) : h = d.run() : o ? o(g.bind(null, !0), !0) : d.run(), m.pause = d.pause.bind(d), m.resume = d.resume.bind(d), m.stop = m, m;
}
function W(e, t = Infinity, n) {
	if (t <= 0 || !T(e) || e.__v_skip || (n ||= /* @__PURE__ */ new Map(), (n.get(e) || 0) >= t)) return e;
	if (n.set(e, t), t--, /* @__PURE__ */ H(e)) W(e.value, t, n);
	else if (x(e)) for (let r = 0; r < e.length; r++) W(e[r], t, n);
	else if (ct(e) || S(e)) e.forEach((e) => {
		W(e, t, n);
	});
	else if (mt(e)) {
		for (let r in e) W(e[r], t, n);
		for (let r of Object.getOwnPropertySymbols(e)) Object.prototype.propertyIsEnumerable.call(e, r) && W(e[r], t, n);
	}
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@vue+runtime-core@3.5.40/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js
var G = [];
function Wn(e) {
	G.push(e);
}
function Gn() {
	G.pop();
}
var Kn = !1;
function K(e, ...t) {
	if (Kn) return;
	Kn = !0, Ut();
	let n = G.length ? G[G.length - 1].component : null, r = n && n.appContext.config.warnHandler, i = qn();
	if (r) $n(r, n, 11, [
		e + t.map((e) => e.toString?.call(e) ?? JSON.stringify(e)).join(""),
		n && n.proxy,
		i.map(({ vnode: e }) => `at <${Ai(n, e.type)}>`).join("\n"),
		i
	]);
	else {
		let n = [`[Vue warn]: ${e}`, ...t];
		i.length && n.push("\n", ...Jn(i)), console.warn(...n);
	}
	Wt(), Kn = !1;
}
function qn() {
	let e = G[G.length - 1];
	if (!e) return [];
	let t = [];
	for (; e;) {
		let n = t[0];
		n && n.vnode === e ? n.recurseCount++ : t.push({
			vnode: e,
			recurseCount: 0
		});
		let r = e.component && e.component.parent;
		e = r && r.vnode;
	}
	return t;
}
function Jn(e) {
	let t = [];
	return e.forEach((e, n) => {
		t.push(...n === 0 ? [] : ["\n"], ...Yn(e));
	}), t;
}
function Yn({ vnode: e, recurseCount: t }) {
	let n = t > 0 ? `... (${t} recursive calls)` : "", r = e.component ? e.component.parent == null : !1, i = ` at <${Ai(e.component, e.type, r)}`, a = ">" + n;
	return e.props ? [
		i,
		...Xn(e.props),
		a
	] : [i + a];
}
function Xn(e) {
	let t = [], n = Object.keys(e);
	return n.slice(0, 3).forEach((n) => {
		t.push(...Zn(n, e[n]));
	}), n.length > 3 && t.push(" ..."), t;
}
function Zn(e, t, n) {
	return w(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : /* @__PURE__ */ H(t) ? (t = Zn(e, /* @__PURE__ */ B(t.value), !0), n ? t : [
		`${e}=Ref<`,
		t,
		">"
	]) : C(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = /* @__PURE__ */ B(t), n ? t : [`${e}=`, t]);
}
var Qn = {
	sp: "serverPrefetch hook",
	bc: "beforeCreate hook",
	c: "created hook",
	bm: "beforeMount hook",
	m: "mounted hook",
	bu: "beforeUpdate hook",
	u: "updated",
	bum: "beforeUnmount hook",
	um: "unmounted hook",
	a: "activated hook",
	da: "deactivated hook",
	ec: "errorCaptured hook",
	rtc: "renderTracked hook",
	rtg: "renderTriggered hook",
	0: "setup function",
	1: "render function",
	2: "watcher getter",
	3: "watcher callback",
	4: "watcher cleanup function",
	5: "native event handler",
	6: "component event handler",
	7: "vnode hook",
	8: "directive hook",
	9: "transition hook",
	10: "app errorHandler",
	11: "app warnHandler",
	12: "ref function",
	13: "async component loader",
	14: "scheduler flush",
	15: "component update",
	16: "app unmount cleanup function"
};
function $n(e, t, n, r) {
	try {
		return r ? e(...r) : e();
	} catch (e) {
		tr(e, t, n);
	}
}
function er(e, t, n, r) {
	if (C(e)) {
		let i = $n(e, t, n, r);
		return i && ut(i) && i.catch((e) => {
			tr(e, t, n);
		}), i;
	}
	if (x(e)) {
		let i = [];
		for (let a = 0; a < e.length; a++) i.push(er(e[a], t, n, r));
		return i;
	} else process.env.NODE_ENV !== "production" && K(`Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`);
}
function tr(e, t, n, r = !0) {
	let i = t ? t.vnode : null, { errorHandler: a, throwUnhandledErrorInProduction: o } = t && t.appContext.config || _;
	if (t) {
		let r = t.parent, i = t.proxy, o = process.env.NODE_ENV === "production" ? `https://vuejs.org/error-reference/#runtime-${n}` : Qn[n];
		for (; r;) {
			let t = r.ec;
			if (t) {
				for (let n = 0; n < t.length; n++) if (t[n](e, i, o) === !1) return;
			}
			r = r.parent;
		}
		if (a) {
			Ut(), $n(a, null, 10, [
				e,
				i,
				o
			]), Wt();
			return;
		}
	}
	nr(e, n, i, r, o);
}
function nr(e, t, n, r = !0, i = !1) {
	if (process.env.NODE_ENV !== "production") {
		let i = Qn[t];
		if (n && Wn(n), K(`Unhandled error${i ? ` during execution of ${i}` : ""}`), n && Gn(), r) throw e;
		console.error(e);
	} else if (i) throw e;
	else console.error(e);
}
var q = [], J = -1, Y = [], X = null, Z = 0, rr = /* @__PURE__ */ Promise.resolve(), ir = null, ar = 100;
function or(e) {
	let t = ir || rr;
	return e ? t.then(this ? e.bind(this) : e) : t;
}
function sr(e) {
	let t = J + 1, n = q.length;
	for (; t < n;) {
		let r = t + n >>> 1, i = q[r], a = fr(i);
		a < e || a === e && i.flags & 2 ? t = r + 1 : n = r;
	}
	return t;
}
function cr(e) {
	if (!(e.flags & 1)) {
		let t = fr(e), n = q[q.length - 1];
		!n || !(e.flags & 2) && t >= fr(n) ? q.push(e) : q.splice(sr(t), 0, e), e.flags |= 1, lr();
	}
}
function lr() {
	ir ||= rr.then(pr);
}
function ur(e) {
	x(e) ? Y.push(...e) : X && e.id === -1 ? X.splice(Z + 1, 0, e) : e.flags & 1 || (Y.push(e), e.flags |= 1), lr();
}
function dr(e) {
	if (Y.length) {
		let t = [...new Set(Y)].sort((e, t) => fr(e) - fr(t));
		if (Y.length = 0, X) {
			X.push(...t);
			return;
		}
		for (X = t, process.env.NODE_ENV !== "production" && (e ||= /* @__PURE__ */ new Map()), Z = 0; Z < X.length; Z++) {
			let t = X[Z];
			process.env.NODE_ENV !== "production" && mr(e, t) || (t.flags & 4 && (t.flags &= -2), t.flags & 8 || t(), t.flags &= -2);
		}
		X = null, Z = 0;
	}
}
var fr = (e) => e.id == null ? e.flags & 2 ? -1 : Infinity : e.id;
function pr(e) {
	process.env.NODE_ENV !== "production" && (e ||= /* @__PURE__ */ new Map());
	let t = process.env.NODE_ENV === "production" ? v : (t) => mr(e, t);
	try {
		for (J = 0; J < q.length; J++) {
			let e = q[J];
			if (e && !(e.flags & 8)) {
				if (process.env.NODE_ENV !== "production" && t(e)) continue;
				e.flags & 4 && (e.flags &= -2), $n(e, e.i, e.i ? 15 : 14), e.flags & 4 || (e.flags &= -2);
			}
		}
	} finally {
		for (; J < q.length; J++) {
			let e = q[J];
			e && (e.flags &= -2);
		}
		J = -1, q.length = 0, dr(e), ir = null, (q.length || Y.length) && pr(e);
	}
}
function mr(e, t) {
	let n = e.get(t) || 0;
	if (n > ar) {
		let e = t.i, n = e && ki(e.type);
		return tr(`Maximum recursive updates exceeded${n ? ` in component <${n}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10), !0;
	}
	return e.set(t, n + 1), !1;
}
var hr = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (yt().__VUE_HMR_RUNTIME__ = {
	createRecord: Sr(_r),
	rerender: Sr(yr),
	reload: Sr(br)
});
var gr = /* @__PURE__ */ new Map();
function _r(e, t) {
	return gr.has(e) ? !1 : (gr.set(e, {
		initialDef: vr(t),
		instances: /* @__PURE__ */ new Set()
	}), !0);
}
function vr(e) {
	return ji(e) ? e.__vccOpts : e;
}
function yr(e, t) {
	let n = gr.get(e);
	n && (n.initialDef.render = t, [...n.instances].forEach((e) => {
		t && (e.render = t, vr(e.type).render = t), e.renderCache = [], e.job.flags & 8 || e.update();
	}));
}
function br(e, t) {
	let n = gr.get(e);
	if (!n) return;
	t = vr(t), xr(n.initialDef, t);
	let r = [...n.instances];
	for (let e = 0; e < r.length; e++) {
		let i = r[e], a = vr(i.type), o = hr.get(a);
		o || (a !== n.initialDef && xr(a, t), hr.set(a, o = /* @__PURE__ */ new Set())), o.add(i), i.appContext.propsCache.delete(i.type), i.appContext.emitsCache.delete(i.type), i.appContext.optionsCache.delete(i.type), i.ceReload ? (o.add(i), i.ceReload(t.styles), o.delete(i)) : i.parent ? cr(() => {
			i.job.flags & 8 || (i.parent.update(), o.delete(i));
		}) : i.appContext.reload ? i.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn("[HMR] Root or manually mounted instance modified. Full reload required."), i.root.ce && i !== i.root && i.root.ce._removeChildStyle(a);
	}
	ur(() => {
		hr.clear();
	});
}
function xr(e, t) {
	y(e, t);
	for (let n in e) n !== "__file" && !(n in t) && delete e[n];
}
function Sr(e) {
	return (t, n) => {
		try {
			return e(t, n);
		} catch (e) {
			console.error(e), console.warn("[HMR] Something went wrong during Vue component hot-reload. Full reload required.");
		}
	};
}
var Cr, wr = [];
function Tr(e, t) {
	Cr = e, Cr ? (Cr.enabled = !0, wr.forEach(({ event: e, args: t }) => Cr.emit(e, ...t)), wr = []) : typeof window < "u" && window.HTMLElement && !(window.navigator?.userAgent)?.includes("jsdom") ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((e) => {
		Tr(e, t);
	}), setTimeout(() => {
		Cr || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, wr = []);
	}, 3e3)) : wr = [];
}
var Q = null, Er = null;
function Dr(e, t, n = !1) {
	let r = xi();
	if (r || Zr) {
		let i = Zr ? Zr._context.provides : r ? r.parent == null || r.ce ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : void 0;
		if (i && e in i) return i[e];
		if (arguments.length > 1) return n && C(t) ? t.call(r && r.proxy) : t;
		process.env.NODE_ENV !== "production" && K(`injection "${String(e)}" not found.`);
	} else process.env.NODE_ENV !== "production" && K("inject() can only be used inside setup() or functional components.");
}
var Or = /* @__PURE__ */ Symbol.for("v-scx"), kr = () => {
	{
		let e = Dr(Or);
		return e || process.env.NODE_ENV !== "production" && K("Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."), e;
	}
};
function Ar(e, t, n = _) {
	let { immediate: r, deep: i, flush: a, once: o } = n;
	process.env.NODE_ENV !== "production" && !t && (r !== void 0 && K("watch() \"immediate\" option is only respected when using the watch(source, callback, options?) signature."), i !== void 0 && K("watch() \"deep\" option is only respected when using the watch(source, callback, options?) signature."), o !== void 0 && K("watch() \"once\" option is only respected when using the watch(source, callback, options?) signature."));
	let s = y({}, n);
	process.env.NODE_ENV !== "production" && (s.onWarn = K);
	let c = t && r || !t && a !== "post", l;
	if (Ti) {
		if (a === "sync") {
			let e = kr();
			l = e.__watcherHandles ||= [];
		} else if (!c) {
			let e = () => {};
			return e.stop = v, e.resume = v, e.pause = v, e;
		}
	}
	let u = bi;
	s.call = (e, t, n) => er(e, u, t, n);
	let d = !1;
	a === "post" ? s.scheduler = (e) => {
		ei(e, u && u.suspense);
	} : a !== "sync" && (d = !0, s.scheduler = (e, t) => {
		t ? e() : cr(e);
	}), s.augmentJob = (e) => {
		t && (e.flags |= 4), d && (e.flags |= 2, u && (e.id = u.uid, e.i = u));
	};
	let f = Un(e, t, s);
	return Ti && (l ? l.push(f) : c && f()), f;
}
function jr(e, t, n) {
	let r = this.proxy, i = w(e) ? e.includes(".") ? Mr(r, e) : () => r[e] : e.bind(r, r), a;
	C(t) ? a = t : (a = t.handler, n = t);
	let o = Ci(this), s = Ar(i, a.bind(r), n);
	return o(), s;
}
function Mr(e, t) {
	let n = t.split(".");
	return () => {
		let t = e;
		for (let e = 0; e < n.length && t; e++) t = t[n[e]];
		return t;
	};
}
var Nr = (e) => e.__isTeleport;
function Pr(e, t) {
	e.shapeFlag & 6 && e.component ? (e.transition = t, Pr(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
yt().requestIdleCallback, yt().cancelIdleCallback;
var Fr = /* @__PURE__ */ Symbol.for("v-ndc"), Ir = (e) => e ? wi(e) ? Ei(e) : Ir(e.parent) : null, Lr = /* @__PURE__ */ y(/* @__PURE__ */ Object.create(null), {
	$: (e) => e,
	$el: (e) => e.vnode.el,
	$data: (e) => e.data,
	$props: (e) => process.env.NODE_ENV === "production" ? e.props : /* @__PURE__ */ Mn(e.props),
	$attrs: (e) => process.env.NODE_ENV === "production" ? e.attrs : /* @__PURE__ */ Mn(e.attrs),
	$slots: (e) => process.env.NODE_ENV === "production" ? e.slots : /* @__PURE__ */ Mn(e.slots),
	$refs: (e) => process.env.NODE_ENV === "production" ? e.refs : /* @__PURE__ */ Mn(e.refs),
	$parent: (e) => Ir(e.parent),
	$root: (e) => Ir(e.root),
	$host: (e) => e.ce,
	$emit: (e) => e.emit,
	$options: (e) => __VUE_OPTIONS_API__ ? Hr(e) : e.type,
	$forceUpdate: (e) => e.f ||= () => {
		cr(e.update);
	},
	$nextTick: (e) => e.n ||= or.bind(e.proxy),
	$watch: (e) => __VUE_OPTIONS_API__ ? jr.bind(e) : v
}), Rr = (e, t) => e !== _ && !e.__isScriptSetup && b(e, t), zr = {
	get({ _: e }, t) {
		if (t === "__v_skip") return !0;
		let { ctx: n, setupState: r, data: i, props: a, accessCache: o, type: s, appContext: c } = e;
		if (process.env.NODE_ENV !== "production" && t === "__isVue") return !0;
		if (t[0] !== "$") {
			let e = o[t];
			if (e !== void 0) switch (e) {
				case 1: return r[t];
				case 2: return i[t];
				case 4: return n[t];
				case 3: return a[t];
			}
			else if (Rr(r, t)) return o[t] = 1, r[t];
			else if (__VUE_OPTIONS_API__ && i !== _ && b(i, t)) return o[t] = 2, i[t];
			else if (b(a, t)) return o[t] = 3, a[t];
			else if (n !== _ && b(n, t)) return o[t] = 4, n[t];
			else (!__VUE_OPTIONS_API__ || Vr) && (o[t] = 0);
		}
		let l = Lr[t], u, d;
		if (l) return t === "$attrs" ? (M(e.attrs, "get", ""), process.env.NODE_ENV) : process.env.NODE_ENV !== "production" && t === "$slots" && M(e, "get", t), l(e);
		if ((u = s.__cssModules) && (u = u[t])) return u;
		if (n !== _ && b(n, t)) return o[t] = 4, n[t];
		if (d = c.config.globalProperties, b(d, t)) return d[t];
		process.env.NODE_ENV;
	},
	set({ _: e }, t, n) {
		let { data: r, setupState: i, ctx: a } = e;
		return Rr(i, t) ? (i[t] = n, !0) : process.env.NODE_ENV !== "production" && i.__isScriptSetup && b(i, t) ? (K(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1) : __VUE_OPTIONS_API__ && r !== _ && b(r, t) ? (r[t] = n, !0) : b(e.props, t) ? (process.env.NODE_ENV !== "production" && K(`Attempting to mutate prop "${t}". Props are readonly.`), !1) : t[0] === "$" && t.slice(1) in e ? (process.env.NODE_ENV !== "production" && K(`Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`), !1) : (process.env.NODE_ENV !== "production" && t in e.appContext.config.globalProperties ? Object.defineProperty(a, t, {
			enumerable: !0,
			configurable: !0,
			value: n
		}) : a[t] = n, !0);
	},
	has({ _: { data: e, setupState: t, accessCache: n, ctx: r, appContext: i, props: a, type: o } }, s) {
		let c;
		return !!(n[s] || __VUE_OPTIONS_API__ && e !== _ && s[0] !== "$" && b(e, s) || Rr(t, s) || b(a, s) || b(r, s) || b(Lr, s) || b(i.config.globalProperties, s) || (c = o.__cssModules) && c[s]);
	},
	defineProperty(e, t, n) {
		return n.get == null ? b(n, "value") && this.set(e, t, n.value, null) : e._.accessCache[t] = 0, Reflect.defineProperty(e, t, n);
	}
};
process.env.NODE_ENV !== "production" && (zr.ownKeys = (e) => (K("Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."), Reflect.ownKeys(e)));
function Br(e) {
	return x(e) ? e.reduce((e, t) => (e[t] = null, e), {}) : e;
}
var Vr = !0;
function Hr(e) {
	let t = e.type, { mixins: n, extends: r } = t, { mixins: i, optionsCache: a, config: { optionMergeStrategies: o } } = e.appContext, s = a.get(t), c;
	return s ? c = s : !i.length && !n && !r ? c = t : (c = {}, i.length && i.forEach((e) => Ur(c, e, o, !0)), Ur(c, t, o)), T(t) && a.set(t, c), c;
}
function Ur(e, t, n, r = !1) {
	let { mixins: i, extends: a } = t;
	a && Ur(e, a, n, !0), i && i.forEach((t) => Ur(e, t, n, !0));
	for (let i in t) if (r && i === "expose") process.env.NODE_ENV !== "production" && K("\"expose\" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.");
	else {
		let r = Wr[i] || n && n[i];
		e[i] = r ? r(e[i], t[i]) : t[i];
	}
	return e;
}
var Wr = {
	data: Gr,
	props: Yr,
	emits: Yr,
	methods: Jr,
	computed: Jr,
	beforeCreate: $,
	created: $,
	beforeMount: $,
	mounted: $,
	beforeUpdate: $,
	updated: $,
	beforeDestroy: $,
	beforeUnmount: $,
	destroyed: $,
	unmounted: $,
	activated: $,
	deactivated: $,
	errorCaptured: $,
	serverPrefetch: $,
	components: Jr,
	directives: Jr,
	watch: Xr,
	provide: Gr,
	inject: Kr
};
function Gr(e, t) {
	return t ? e ? function() {
		return y(C(e) ? e.call(this, this) : e, C(t) ? t.call(this, this) : t);
	} : t : e;
}
function Kr(e, t) {
	return Jr(qr(e), qr(t));
}
function qr(e) {
	if (x(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) t[e[n]] = e[n];
		return t;
	}
	return e;
}
function $(e, t) {
	return e ? [...new Set([].concat(e, t))] : t;
}
function Jr(e, t) {
	return e ? y(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function Yr(e, t) {
	return e ? x(e) && x(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : y(/* @__PURE__ */ Object.create(null), Br(e), Br(t ?? {})) : t;
}
function Xr(e, t) {
	if (!e) return t;
	if (!t) return e;
	let n = y(/* @__PURE__ */ Object.create(null), e);
	for (let r in t) n[r] = $(e[r], t[r]);
	return n;
}
var Zr = null, Qr = {}, $r = (e) => Object.getPrototypeOf(e) === Qr, ei = ni, ti = (e) => e.__isSuspense;
function ni(e, t) {
	t && t.pendingBranch ? x(e) ? t.effects.push(...e) : t.effects.push(e) : ur(e);
}
var ri = /* @__PURE__ */ Symbol.for("v-fgt"), ii = /* @__PURE__ */ Symbol.for("v-txt"), ai = /* @__PURE__ */ Symbol.for("v-cmt");
function oi(e) {
	return e ? e.__v_isVNode === !0 : !1;
}
var si, ci = (...e) => pi(...si ? si(e, Q) : e), li = ({ key: e }) => e ?? null, ui = ({ ref: e, ref_key: t, ref_for: n }) => (typeof e == "number" && (e = "" + e), e == null ? null : w(e) || /* @__PURE__ */ H(e) || C(e) ? {
	i: Q,
	r: e,
	k: t,
	f: !!n
} : e);
function di(e, t = null, n = null, r = 0, i = null, a = e === ri ? 0 : 1, o = !1, s = !1) {
	let c = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e,
		props: t,
		key: t && li(t),
		ref: t && ui(t),
		scopeId: Er,
		slotScopeIds: null,
		children: n,
		component: null,
		suspense: null,
		ssContent: null,
		ssFallback: null,
		dirs: null,
		transition: null,
		el: null,
		anchor: null,
		target: null,
		targetStart: null,
		targetAnchor: null,
		staticCount: 0,
		shapeFlag: a,
		patchFlag: r,
		dynamicProps: i,
		dynamicChildren: null,
		appContext: null,
		ctx: Q
	};
	return s ? (vi(c, n), a & 128 && e.normalize(c)) : n && (c.shapeFlag |= w(n) ? 8 : 16), process.env.NODE_ENV !== "production" && c.key !== c.key && K("VNode created with invalid key (NaN). VNode type:", c.type), c;
}
var fi = process.env.NODE_ENV === "production" ? pi : ci;
function pi(e, t = null, n = null, r = 0, i = null, a = !1) {
	if ((!e || e === Fr) && (process.env.NODE_ENV !== "production" && !e && K(`Invalid vnode type when creating vnode: ${e}.`), e = ai), oi(e)) {
		let r = hi(e, t, !0);
		return n && vi(r, n), r.patchFlag = -2, r;
	}
	if (ji(e) && (e = e.__vccOpts), t) {
		t = mi(t);
		let { class: e, style: n } = t;
		e && !w(e) && (t.class = Tt(e)), T(n) && (/* @__PURE__ */ Pn(n) && !x(n) && (n = y({}, n)), t.style = bt(n));
	}
	let o = w(e) ? 1 : ti(e) ? 128 : Nr(e) ? 64 : T(e) ? 4 : C(e) ? 2 : 0;
	return process.env.NODE_ENV !== "production" && o & 4 && /* @__PURE__ */ Pn(e) && (e = /* @__PURE__ */ B(e), K("Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.", "\nComponent that was made reactive: ", e)), di(e, t, n, r, i, o, a, !0);
}
function mi(e) {
	return e ? /* @__PURE__ */ Pn(e) || $r(e) ? y({}, e) : e : null;
}
function hi(e, t, n = !1, r = !1) {
	let { props: i, ref: a, patchFlag: o, children: s, transition: c } = e, l = t ? yi(i || {}, t) : i, u = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e.type,
		props: l,
		key: l && li(l),
		ref: t && t.ref ? n && a ? x(a) ? a.concat(ui(t)) : [a, ui(t)] : ui(t) : a,
		scopeId: e.scopeId,
		slotScopeIds: e.slotScopeIds,
		children: process.env.NODE_ENV !== "production" && o === -1 && x(s) ? s.map(gi) : s,
		target: e.target,
		targetStart: e.targetStart,
		targetAnchor: e.targetAnchor,
		staticCount: e.staticCount,
		shapeFlag: e.shapeFlag,
		patchFlag: t && e.type !== ri ? o === -1 ? 16 : o | 16 : o,
		dynamicProps: e.dynamicProps,
		dynamicChildren: e.dynamicChildren,
		appContext: e.appContext,
		dirs: e.dirs,
		transition: c,
		component: e.component,
		suspense: e.suspense,
		ssContent: e.ssContent && hi(e.ssContent),
		ssFallback: e.ssFallback && hi(e.ssFallback),
		placeholder: e.placeholder,
		el: e.el,
		anchor: e.anchor,
		ctx: e.ctx,
		ce: e.ce
	};
	return c && r && Pr(u, c.clone(u)), u;
}
function gi(e) {
	let t = hi(e);
	return x(e.children) && (t.children = e.children.map(gi)), t;
}
function _i(e = " ", t = 0) {
	return fi(ii, null, e, t);
}
function vi(e, t) {
	let n = 0, { shapeFlag: r } = e;
	if (t == null) t = null;
	else if (x(t)) n = 16;
	else if (typeof t == "object") if (r & 65) {
		let n = t.default;
		n && (n._c && (n._d = !1), vi(e, n()), n._c && (n._d = !0));
		return;
	} else n = 32, !t._ && !$r(t) && (t._ctx = Q);
	else if (C(t)) {
		if (r & 65) {
			vi(e, { default: t });
			return;
		}
		t = {
			default: t,
			_ctx: Q
		}, n = 32;
	} else t = String(t), r & 64 ? (n = 16, t = [_i(t)]) : n = 8;
	e.children = t, e.shapeFlag |= n;
}
function yi(...e) {
	let t = {};
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		for (let e in r) if (e === "class") t.class !== r.class && (t.class = Tt([t.class, r.class]));
		else if (e === "style") t.style = bt([t.style, r.style]);
		else if (it(e)) {
			let n = t[e], i = r[e];
			i && n !== i && !(x(n) && n.includes(i)) ? t[e] = n ? [].concat(n, i) : i : i == null && n == null && !at(e) && (t[e] = i);
		} else e !== "" && (t[e] = r[e]);
	}
	return t;
}
var bi = null, xi = () => bi || Q, Si;
{
	let e = yt(), t = (t, n) => {
		let r;
		return (r = e[t]) || (r = e[t] = []), r.push(n), (e) => {
			r.length > 1 ? r.forEach((t) => t(e)) : r[0](e);
		};
	};
	Si = t("__VUE_INSTANCE_SETTERS__", (e) => bi = e), t("__VUE_SSR_SETTERS__", (e) => Ti = e);
}
var Ci = (e) => {
	let t = bi;
	return Si(e), e.scope.on(), () => {
		e.scope.off(), Si(t);
	};
};
function wi(e) {
	return e.vnode.shapeFlag & 4;
}
var Ti = !1;
process.env.NODE_ENV;
function Ei(e) {
	return e.exposed ? e.exposeProxy ||= new Proxy(zn(Fn(e.exposed)), {
		get(t, n) {
			if (n in t) return t[n];
			if (n in Lr) return Lr[n](e);
		},
		has(e, t) {
			return t in e || t in Lr;
		}
	}) : e.proxy;
}
var Di = /(?:^|[-_])\w/g, Oi = (e) => e.replace(Di, (e) => e.toUpperCase()).replace(/[-_]/g, "");
function ki(e, t = !0) {
	return C(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function Ai(e, t, n = !1) {
	let r = ki(t);
	if (!r && t.__file) {
		let e = t.__file.match(/([^/\\]+)\.\w+$/);
		e && (r = e[1]);
	}
	if (!r && e) {
		let n = (e) => {
			for (let n in e) if (e[n] === t) return n;
		};
		r = n(e.components) || e.parent && n(e.parent.type.components) || n(e.appContext.components);
	}
	return r ? Oi(r) : n ? "App" : "Anonymous";
}
function ji(e) {
	return C(e) && "__vccOpts" in e;
}
function Mi() {
	if (process.env.NODE_ENV === "production" || typeof window > "u") return;
	let e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, n = { style: "color:#f5222d" }, r = { style: "color:#eb2f96" }, i = {
		__vue_custom_formatter: !0,
		header(t) {
			if (!T(t)) return null;
			if (t.__isVue) return [
				"div",
				e,
				"VueInstance"
			];
			if (/* @__PURE__ */ H(t)) {
				Ut();
				let n = t.value;
				return Wt(), [
					"div",
					{},
					[
						"span",
						e,
						u(t)
					],
					"<",
					s(n),
					">"
				];
			} else if (/* @__PURE__ */ L(t)) return [
				"div",
				{},
				[
					"span",
					e,
					/* @__PURE__ */ z(t) ? "ShallowReactive" : "Reactive"
				],
				"<",
				s(t),
				`>${/* @__PURE__ */ R(t) ? " (readonly)" : ""}`
			];
			else if (/* @__PURE__ */ R(t)) return [
				"div",
				{},
				[
					"span",
					e,
					/* @__PURE__ */ z(t) ? "ShallowReadonly" : "Readonly"
				],
				"<",
				s(t),
				">"
			];
			return null;
		},
		hasBody(e) {
			return e && e.__isVue;
		},
		body(e) {
			if (e && e.__isVue) return [
				"div",
				{},
				...a(e.$)
			];
		}
	};
	function a(e) {
		let t = [];
		e.type.props && e.props && t.push(o("props", /* @__PURE__ */ B(e.props))), e.setupState !== _ && t.push(o("setup", e.setupState)), e.data !== _ && t.push(o("data", /* @__PURE__ */ B(e.data)));
		let n = c(e, "computed");
		n && t.push(o("computed", n));
		let i = c(e, "inject");
		return i && t.push(o("injected", i)), t.push([
			"div",
			{},
			[
				"span",
				{ style: r.style + ";opacity:0.66" },
				"$ (internal): "
			],
			["object", { object: e }]
		]), t;
	}
	function o(e, t) {
		return t = y({}, t), Object.keys(t).length ? [
			"div",
			{ style: "line-height:1.25em;margin-bottom:0.6em" },
			[
				"div",
				{ style: "color:#476582" },
				e
			],
			[
				"div",
				{ style: "padding-left:1.25em" },
				...Object.keys(t).map((e) => [
					"div",
					{},
					[
						"span",
						r,
						e + ": "
					],
					s(t[e], !1)
				])
			]
		] : ["span", {}];
	}
	function s(e, i = !0) {
		return typeof e == "number" ? [
			"span",
			t,
			e
		] : typeof e == "string" ? [
			"span",
			n,
			JSON.stringify(e)
		] : typeof e == "boolean" ? [
			"span",
			r,
			e
		] : T(e) ? ["object", { object: i ? /* @__PURE__ */ B(e) : e }] : [
			"span",
			n,
			String(e)
		];
	}
	function c(e, t) {
		let n = e.type;
		if (C(n)) return;
		let r = {};
		for (let i in e.ctx) l(n, i, t) && (r[i] = e.ctx[i]);
		return r;
	}
	function l(e, t, n) {
		let r = e[n];
		if (x(r) && r.includes(t) || T(r) && t in r || e.extends && l(e.extends, t, n) || e.mixins && e.mixins.some((e) => l(e, t, n))) return !0;
	}
	function u(e) {
		return /* @__PURE__ */ z(e) ? "ShallowRef" : e.effect ? "ComputedRef" : "Ref";
	}
	window.devtoolsFormatters ? window.devtoolsFormatters.push(i) : window.devtoolsFormatters = [i];
}
process.env.NODE_ENV, process.env.NODE_ENV, process.env.NODE_ENV;
//#endregion
//#region ../../node_modules/.pnpm/vue@3.5.40_typescript@6.0.3/node_modules/vue/dist/vue.runtime.esm-bundler.js
function Ni() {
	Mi();
}
process.env.NODE_ENV !== "production" && Ni();
//#endregion
//#region src/typeguards/shippablePackages.ts
var Pi = (e) => "package" in e, Fi = (e) => "multicollo" in e, Ii = (e) => "packages" in e, Li = (e) => "multicollo" in e;
//#endregion
export { p as $, o as A, ve as B, de as C, Fe as Ct, ue as D, le as E, s as F, Ce as G, be as H, u as I, d as J, xe as K, he as L, i as M, c as N, e as O, l as P, Be as Q, ge as R, ce as S, Pe as St, pe as T, f as U, _e as V, Se as W, Te as X, we as Y, Ee as Z, Le as _, ie as _t, et as a, ne as at, n as b, Oe as bt, Ge as c, De as ct, Je as d, He as dt, je as et, Ye as f, Ue as ft, $e as g, g as gt, Qe as h, h as ht, Ii as i, ee as it, a as j, Ie as k, Ke as l, Re as lt, Ze as m, Ve as mt, Pi as n, Ne as nt, nt as o, re as ot, Xe as p, We as pt, Ae as q, Li as r, te as rt, tt as s, m as st, Fi as t, Me as tt, qe as u, ze as ut, t as v, ae as vt, fe as w, se as wt, r as x, ke as xt, me as y, oe as yt, ye as z };
